export default {
  title: {
    payErrorJump: '收銀台'
  },
  msg: {
    title: '短信'
  },
  rate: {
    title: 'IDD收費表',
    searchNoResult: '無結果',
    searchTip: '搜索',
    tableTitleLeft: '國家 / 地區',
    tableTitleCenter: '區號',
    tableTitleRight: '收費',
    tableTitleRightUnit: '(HKD/分鐘)',
    cancel: '取消',
    tipTitle: '溫馨說明',
    tip1: '1. 以下收費以港幣為單位；所有收費以每分鐘計算，不足一分鐘亦作一分鐘計算。',
    tip2: '2. 香港號碼長途電話服務需另外計算香港/中港通話分鐘或香港/中港通話分鐘收費。',
    tip3: '3. 廣州博元訊息服務有限公司保留對以下優惠條款及細則之最終決定權。收費如有更改恕不另行通知。'
  },
  company: {
    title: '關於博元',
    ERCodeDesc: '博元訊息',
    info: '博元訊息（MB）集團是創立於 2000 年的一家電訊增值服務提供者，並在廣州和香港均設置了分支機構，並獲得了香港通訊事務管理局頒發的「流動虛擬網路營辦商服務」牌照（牌照號碼：1687）和中國人民共和國工業和信息化部頒發的「中華人民共和國增值電信業務經營許可證」（經營許可證編號：A1-20184242）。',
    gotoMB: '前往博元訊息網站'
  },
  privacyText: {
    title: '易博通eSender隱私政策',
    summary:
      {
        title: '摘要',
        text: '廣州博元訊息服務有限公司。（「 eSender」或「我們」或「我們的」或「我們的」或其他類似代詞）非常重視您的隱私問題。請閱讀以下內容，以瞭解有關我們的隱私政策（「政策」）的更多信息。本政策詳細說明瞭我們如何接收，收集和使用eSender軟件上提供服務有關的信息。 （以上統稱為「服務」）。使用本服務時，即表示您接受本政策中所述的政策和慣例，因為該政策可能會不時進行修改。每次您使用服務時，即表示您同意並明確同意我們按照本政策的規定收集，使用和披露您提供的信息。'
      },
    one: {
      title: '一.我們會收集閣下的哪些資訊？',
      text1: '若閣下設定易博通eSender  帳戶，並使用易博通eSender提供的服務，我們將會收集閣下的資訊。我們會收集閣下的',
      text2: '設備型號、操作系統、位置信息、手機讀寫、麥克風、通訊錄、攝像頭、唯一設備標識符、登錄IP地址、接入網絡的方式、類型和狀態、網絡質量數據、操作日誌、暱稱、手機號碼以及通話和短信記錄',
      text3: '，這些信息是為提供服務必須收集的基礎信息。同時閣下可以提供更多資訊，讓閣下的個人資料更精細與受歡迎，所收集到的信息我們將妥善存儲和謹慎使用。'
    },
    two: {
      title: '二.第三方SDK目錄',
      substile1: '1) 極光(Jiguang)SDK，用於消息推送',
      text2: 'A.獲取權限：',
      text3: '•獲取您的設備信息',
      text4: '•獲取您的讀寫外部存儲',
      text5: '•查看您的網絡鏈接狀態 ',
      text6: 'B.使用目的',
      text7: '•推送消息',
      text8: 'C.處理方式',
      text9: '•採用替換，去標識，加密，匿名化方式對個人信息進行脫敏展示',
      text10: 'D.極光隱私協議',
      subtitle2: '2)友盟UShare SDK',
      text20: '為了向閣下提供一鍵分享服務，我們的產品集成友盟+ Ushare SDK，友盟Ushare SDK需要收集閣下的 設備Mac地址、唯一設備識別碼（IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息）以及閣下需要分享的社交賬號公開信息，以便完成一鍵分享服務。並通過地理位置校准報表數據準確性，提供基礎反作弊服務。為了閣下的信息安全，我們已與第三方SDK服務商進行數據安全保密約定，這些公司會嚴格遵守我們的數據隱私和安全要求。\n' +
        '        除非得到閣下的同意，我們不會與其共享閣下的個人身份信息。為便於閣下更好地瞭解【友盟+】採集的數據類型及用途，以及何保護閣下的個人信息.',
      text21: '閣下可以登陸',
      text22: '瞭解【友盟+】隱私權政策 .',
      subtitle3: '3) 騰訊Bugly SDK',
      text30: '為了更好排查崩潰問題,幫助APP提升穩定性，我們的產品集成了騰訊Bugly SDK，騰訊Bugly SDK需要收集Android系統版本，廠商系統版本，內存空間佔用大小等信息，為了閣下的信息安全，我們已與第三方SDK服務商進行數據安全保密約定，這些公司會嚴格遵守我們的數據隱私和安全要求。 除非得到閣下的同意，我們不會與其共享閣下的個人身份信息。為便於閣下更好地瞭解【Bugly SDK】採集的數據類型及用途，以及何保護閣下的個人信息.',
      text31: '閣下可以訪問 ',
      text32: ' , 瞭解Bugly SDK隱私保護聲明.'
    },
    three: {
      title: '三.我們會如何使用閣下的資訊？',
      text1: '我們會使用閣下的資訊來提供閣下的易博通eSender服務，允許閣下與其他使用者通訊，以及使用易博通eSender公開平台的功能。我們會使用閣下的資訊來設定帳戶、促進通訊、提供支援、允許閣下存取易博通eSender功能，並改善易博通eSender服務。易博通eSender會使用閣下所使用的WeChat應用，以驗證及保護閣下的帳戶，也會為重要管理因素而使用，且易博通eSender不會將這些聯絡管道用於推銷或行銷。'
    },
    four: {
      title: '四.我們會與誰分享閣下的資料？',
      text1: '我們會使用第三方支援服務，例如使用WeChat公共平台來提供帳戶驗證服務。我們使用這些第三方服務來處理或儲存閣下的資訊時，會以本政策所載的目的為限。我們也會和博元相關集團公司共用閣下的資訊，並根據法律要求來共用。除以上所列之目的外，若無閣下的事前明文同意，易博通eSender不會與第三方共用閣下的資料。任何我們與之分享用戶資訊的第三方服務商（由我們所揀選），都會提供與本政策所述相同，或者同等級的用戶資訊保護標準。'
    },
    five: {
      title: '五.我們保留閣下資料的時間會持續多久？',
      text1: '我們保留閣下資訊的時間會依據資訊類型而定，例如登入資料會保留長達 90 天，自收集資料之日起算。'
    },
    six: {
      title: '六.我要如何行使我對資料的權利？',
      text1: '閣下對閣下的資料及我們使用閣下資料的方式有特殊權利。這些權利包含閣下存取資料的方式、消除資料的方式、限制使用閣下資料的方式、拒絕使用資料，以及取得閣下的資訊副本。'
    },
    seven: {
      title: '七.爭議解決',
      text1: '如閣下有任何疑慮或投訴事項，請聯絡我們：',
      text2: '香港 +852  2156 6888',
      text3: '中國 400  888 4333'
    },
    eight: {
      title: '八.我們如何向閣下通知變更？',
      text1: ' 若本隱私政策有任何重大變更，在變更生效前，我們會傳送通知給閣下。',
      text2: '我們重視閣下的隱私。本隱私政策旨在告知閣下，對於閣下向我們提供的任何資訊，或閣下因使用易博通eSender而產生之資訊，閣下可以做出的選擇以及我們的慣例。',
      text3: '使用我們的服務（例如易博通eSender行動應用程式、博元公司網站  www.multi-byte.com 或提供易博通eSender服務之任何第三方平台）（合稱為「易博通eSender」）包含處理閣下的資訊之行為。閣下有必要瞭解對閣下資訊的收集與使用過程，以及閣下可以如何對其進行管理，這些都是很重要的資訊。請詳閱此隱私政策。'
    },
    nice: {
      title: '九.聯絡我們',
      text1: '如閣下有任何疑慮或投訴事項，請聯絡我們：',
      text2: '香港 +852  2156 6888',
      text3: '中國 400  888 4333'
    },
    update: {
      text1: '廣州博元訊息服務有限公司-最後修訂'
    }
  },
  regulation: {
    title: '服務條款',
    clause: {
      clauseTitle1: ' 「易博通」服務計劃同意書 (香港號碼)',
      clause1: ' 1、以上服務提供於微信「易博通eSender」公眾號綁定香港號碼查閱及發送短訊服務。博元訊息科技有限公司(「博元」)亦可提供實體智能卡予客戶攜號轉台或使用話音﹑數據及手機發送短訊服務，唯客戶需要繳付智能卡費用及／或速遞費用（如適用）。話音﹑數據及手機發送短服務需另行收費。',
      clause2: ' 2、於微信發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽博元網頁www.multi-byte.com或本公眾號',
      clause3: ' 3、當服務有效期屆滿前，博元將發送訊息予客戶登記之香港號碼提示客戶，客戶可於已於綁定香港號碼的微信「 易博通eSender」公眾號查閱，並可於效期屆滿前自行於本公眾號或博元網頁www.multi-byte.com繳費以延長服務有效期',
      clause4: ' 4、當服務有效期完結時，服務會被暫停。客戶可於微信或博元網頁繳費並重啓服務。暫停期間之訊息將不獲補發',
      clause5: ' 5、如服務因任何原故而停用超過7日或終止服務，客戶同意屆時必須放棄該分配的香港號碼並歸還予博元',
      clause6: ' 6、服務計劃中的香港號碼不能更改',
      clause7: ' 7、如服務因任何原故而停用，所預繳之費用將不獲退還',
      clause8: ' 8、任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品。',
      clause9: ' 9、此服務受博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁',
      clause10: ' 10、上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申請之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途',
      clause11: ' 11、博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束',
      clauseTitle2: ' 「易博通」服務計劃同意書 (香港號碼-攜號轉台服務)',
      clause12: ' 12、以上服務提供於微信「易博通eSender」公眾號綁定香港號碼查閱及發送短訊服務。博元訊息科技有限公司(「博元」)亦可提供實體智能卡予客戶攜號轉台或使用話音﹑數據及手機發送短訊服務，唯客戶需要繳付智能卡費用及／或速遞費用（如適用）。話音﹑數據及手機發送短服務需另行收費',
      clause13: ' 13、於微信發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽博元網頁www.multi-byte.com或本公眾號',
      clause14: ' 14、當服務有效期屆滿前，博元將發送訊息予客戶登記之香港號碼提示客戶，客戶可於已於綁定香港號碼的微信「 易博通eSender」公眾號查閱，並可於效期屆滿前自行於本公眾號或博元網頁www.multi-byte.com繳費以延長服務有效期',
      clause15: ' 15、當服務有效期完結時，服務會被暫停。客戶可於微信或博元網頁繳費並重啓服務。暫停期間之訊息將不獲補發',
      clause16: ' 16、如服務因任何原故而停用超過7日或終止服務，客戶同意屆時必須放棄該分配的香港號碼並歸還予博元',
      clause17: ' 17、服務計劃中的香港號碼不能更改',
      clause18: ' 18、如服務因任何原故而停用，所預繳之費用將不獲退還',
      clause19: ' 19、任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品',
      clause20: ' 20、本人明白有關流動號碼的轉攜並不影響有關流動號碼成功轉攜前本人在供號網絡營辦商適用的服務條款與細則下對供號網絡營辦商的責任',
      clause22: ' 21、生效時間受供號網絡營辦商確認上述資料及供號網絡營辦商與博元之間按電訊管理局局長所發出的與實施流動電話號碼可攜性有關的實務守則技術安排的限制。博元獲明示授權更改博元訊息合理地認為合適的生效時間',
      clause23: ' 22、有關流動號碼若由於本人未有提供完整的資料，或提供錯誤或失實的資料或因博元訊息未能合理控制的任何理由，而導致流動電話號碼無法攜帶至博元的網絡，博元有權取消本轉攜申請',
      clause24: ' 23、除任何無法卸除的法律責任外，本人同意因本申請和相關號碼轉攜安排引致或造成本人或其他任何人士蒙受損失或損害，博元無需對本人或任何其他人士負上法律責任 (不論是在合約、侵權或其他方面)。 ',
      clause25: ' 24、此服務受博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁',
      clause26: ' 25、上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申請之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途',
      clause27: ' 26、博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束',
      clauseTitle3: ' 「易博通」服務計劃同意書 (中國內地號碼)',
      clause28: ' 27、以上服務不提供實體智能卡',
      clause29: ' 28、以上服務只提供於「易博通eSender」微信公眾號綁定中國內地號碼查閱及發送短訊服務，現階段並不包括話音或數據服務。發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽博元網頁www.multi-byte.com',
      clause30: ' 29、當服務有效期屆滿前，博元訊息科技有限公司(「博元」)將發送訊息予客戶登記之中國內地號碼提示客戶，客戶可於已於綁定中國內地號碼的「 易博通eSender」微信公眾號查閱，並可於效期屆滿前自行於微信或博元網頁www.multi-byte.com繳費以延長服務有效期',
      clause31: ' 30、當服務有效期完結時，服務會被暫停。客戶可於微信或博元網頁繳費並重啓服務。暫停期間之訊息將不獲補發',
      clause32: ' 31、如服務因任何原故而停用超過30日或終止服務，客戶同意屆時必須放棄該分配的中國內地號碼並歸還予博元',
      clause33: ' 32、服務計劃中的中國內地號碼不能更改',
      clause34: ' 33、服務計劃中的中國內地號碼祇適用於「易博通」服務',
      clause35: ' 34、如服務因任何原故而停用，所預繳之費用將不獲退還',
      clause36: ' 35、任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品',
      clause37: ' 36、中華人民共和國工業和信息部文件《電話用戶真實身份信息登記實施規範》，申請中國內地流動電話號碼必須實名登記，實名登記的年齡範圍必須在16歲以上。博元須向閣下蒐集閣下的個人資料，包括姓名、流動電話號碼、聯絡方法﹑港澳身份證﹑台灣居民來往大陸通行證、中國公民身份證、護照或其它身份證明文件﹑免冠像片及自拍影片的資料等(「上述資料」)，以協助閣下向中國內地當局辦理實名登記(「上述登記」)。上述資料會按中國內地政府推行的流動電話號碼實名登記政策有所更改。閣下沒有義務向博元提供上述資料，但如閣下不提供個人資料，中國內地當局會按相關政策指令停止閣下的中國內地號碼服務，閣下將無法開通使用或繼續使用涉及中國內地流動電話號碼的電訊通訊服務，詳情請瀏覽博元網頁www.multi-byte.com',
      clause38: ' 37、用戶如有虛假交易的行為﹑以轉售或詐騙為目的使用本服務，博元有權在無任何補償或事先通知情況下，終止閣下的中國內地號碼服務',
      clause39: ' 38、用戶不得將易博通服務用於電信資訊網路詐騙及其他違法行為，如出現電話詐騙、網路詐騙、垃圾短信投訴情況，博元有權在無任何補償或事先通知情況下，永久終止閣下的易博通號碼。',
      clause40: ' 39、此服務受博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁www.multi-byte.com',
      clause41: ' 40、上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申請之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途',
      clause42: ' 41、博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束',
      clauseEnd: ' 本人/本公司已細閱及明白本附加協議之條款/及條件，並同意受彼等約束。'
    }
  },
  charge: {
    title: '產品收費表',
    select: {
      option1: '所有套餐',
      option2: '中國香港號碼套餐',
      option3: '中國內地號碼套餐'
    },
    price: '價錢',
    dayNum: '日數',
    receiveMsg: '接收短訊',
    data: '流動數據',
    limitless: '無限',
    service: '服務',
    phoneTime: '通話分鐘',
    phoneTimeAndData: '通話分鐘、流動數據',
    notAvailable: '不適用',
    day: '天',
    minute: '分鐘',
    hk: '(香港)',
    mo: '(澳門)',
    cn_mo: '(中國及澳門)',
    hkTableTitle: '香港號碼套餐',
    package: {
      p1: '微信收短信 （免SIM卡套餐）',
      p2: '實體 SIM 卡 / eSIM 套餐',
      p3: 'eSIM 套餐',
      p4: '實體 SIM 卡 / eSIM 套餐'
    },
    tips: {
      t1: '(只適用於香港地區)',
      t2: '( 適用於中國香港 )',
      t3: '(只適用於香港及澳門地區)',
      t4: '( 適用於中國香港及澳門 )',
      t5: '( 適用於中國香港及澳門 )',
      t6: '( 適用於中國內地、香港、澳門、台灣 )',
      t7: '( 適用於中國內地、香港、澳門、台灣、美國、加拿大、韓國、日本、新加坡、馬來西亞以及泰國 )',
      t8: '( 適用於中國內地和香港 )',
      t9: '(只適用於香港地區)',
      t10: '(適用於多個地區)'
    }
  },
  provisionNumber: {
    info: {
      head: '開通號碼',
      title: '開通手機號',
      tips: '每個帳戶最多可以申請 2 個中國香港號碼及 1 個中國內地號碼。',
      no1: {
        title: '中國香港手機號',
        info: '2 款本地開通方式仼您選'
      },
      no2: {
        title: '中國内地手機號',
        info: '優惠期內限時 7 天免費試用'
      },
      no3: {
        title: '國外手機號',
        info: '多款本地開通方式仼您選'
      }
    },
    infoHk: {
      head: '中國香港手機號登記',
      headTips: '香港特區政府於2021年6月1日公布訂立《電訊（登記用戶識別卡）規例》，並於同年9月1日實施，以落實電話智能卡實名登記制度，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。',
      title: '開通中國香港手機號',
      tips: '每個帳戶多個只可以申請 2 個中國香港手機號。',
      no1: {
        title: '一般手機號登記',
        info: '無SIM卡服務，App和微信收取短訊，App接聽撥打電話'
      },
      no2: {
        title: '全新香港手機號碼登記',
        info: '新號首發，限量供應',
        info2: '無SIM卡服務，App和微信收取短訊，App接聽撥打電話'
      },
      no3: {
        title: '實體智能卡',
        info: '實體sim卡，含數據及語音'
      },
      no4: {
        title: 'eSIM',
        info: '只支援特定型號手機裝置'
      },
      no5: {
        title: '攜號轉台 (MNP)',
        info: '需提供攜號資料'
      }
    },
    infoCn: {
      head: '中國内地手機號',
      title: '開通中國内地號碼',
      tips: '每個帳戶只可以申請 1 個中國内地手機號。',
      no1: {
        title: '普通手機號碼',
        info: '免費體驗期 7 天，無sim卡，微信和 App 收取短訊、App接聽撥打電話'
      },
      no2: {
        title: '特選號碼',
        info: '配對特定計劃'
      }
    },
    infoExt: {
      head: '訂購外國手機號',
      title: '訂購外國手機號',
      tips: '每個帳戶最多可以申請 X 個國外手機號。',
      areaTips: '請選擇地區...',
      area: {
        USA: '美國',
        UK: '英國',
        POL: '波蘭'
      },
      no1: {
        title: '英國手機號',
        info: '無 SIM卡，微信和 App 收取短訊'
      },
      no2: {
        title: '美國手機號',
        info: '無 SIM卡，微信和 App 收取短訊'
      },
      no3: {
        title: '波蘭手機號',
        info: '無 SIM卡，微信和 App 收取短訊'
      },
      no4: {
        title: '外國手機號',
        info: '英國 / 波蘭 號碼開通任您選'
      }
    }
  },
  payment: {
    head: '付款',
    title: '付款',
    phoneNo: '號碼',
    topUpNo: '充值號碼',
    amount: '交易金額',
    totalAmount: '總額',
    button: '付款',
    previous: '返回',
    paySuccess: '支付成功',
    confirm: '確定',
    chargeBalance: '支付金額',
    chargeType: '交易方式',
    tradeNo: '參考編號',
    payFail: '支付不成功',
    repay: '重新支付',
    canclePay: '取消交易',
    needHelp: '需要幫助?',
    confirmTips: '是否確定取消購買並離開？',
    confirmSure: '繼續購買',
    confirmLeave: '離開購買',
    selectPayType: '請選擇支付方式',
    money: {
      BALANCE: {
        title: '易博通餘額',
        tips: ''
      },
      HKD: {
        title: '港幣支付',
        tips: ''
      },
      CNY: {
        title: '人民幣支付',
        tips: '當前匯率為 100人民幣 = 100港幣'
      },
      NTD: {
        title: '台幣支付',
        tips: '台灣超商代碼繳費（繳費後2小時生效）'
      },
      KRW: {
        title: '韓幣支付',
        tips: '當前匯率為 160韓元 = 1港幣'
      },
      RM: {
        title: '吉令支付',
        tips: '當前匯率為 60吉令 = 100港幣'
      },
      RU: {
        title: '盧布支付',
        tips: ''
      }
    },
    payType: {
      A: '支付寶',
      B: '余額支付',
      W: '微信支付',
      AHK: '支付寶香港',
      WHK: '微信支付香港',
      U: '銀聯',
      P: 'Paypal',
      ABP: 'Aerobile Pay',
      L: 'LinePay',
      S: 'Google支付',
      KK: 'KakaoPay',
      TN: 'Touch\'n Go',
      GB: 'GrabPay',
      BT: 'Boost',
      MAY: 'Maybank',
      APP: 'Apple Pay',
      ASPA: 'Apple Pay',
      YOO: 'YooMoney',
      QIWI: 'QIWI'
    }
  },
  balanceInfo: {
    head: '餘額充值',
    choosePhone: '選擇號碼',
    balance: '餘額',
    authPass: '已實名認證',
    authFail: '未實名認證',
    auditing: '實名認証審核中',
    auditing2: '正在審核中',
    unAuth: '沒有實名認證',
    unAuthStatus: '未實名認證，無法使用',
    balanceRecharge: '餘額充值',
    tips1: '備注：充值餘額，是不會延長該號碼的服務期限，但如有足夠餘額便可用作購買套餐計劃延長號碼的有效期或發送短信。',
    tips2: '所預繳之費用將不獲退還及/或不可兌換其他服務及/或產品。',
    nextButton: '下一步',
    noPhoneTips: '您當前沒有號碼，請先購買號碼',
    status: '狀態',
    normal: '正常',
    expired: '失效',
    active: '生效',
    numExpired: '過期',
    notRealName: '未實名',
    noNumber: '無號碼',
    endDate: '到期日',
    notApplicable: '不適用'
  },
  payProcess: {
    tips1: '正在支付中',
    tips2: '請耐心等候，切勿關閉頁面，系統正為您處理相關購買。',
    btn: '取消'
  },
  question: {
    title: '常見問題',
    title2: '我要反饋',
    line01: {
      title: '原微信用戶，如何使用新版本APP？',
      content1: '第一步）先在新版本APP上，用電郵註冊一個會員 ； 第二步）新會員登入APP ；第三步） 點擊個人->點擊頂端個人頭像-登入方式綁定->快速登入設定，選擇「微信綁定」； 第四步）綁定成功後，重新登入即可使用已辦理的號碼；',
      content2: ''
    },
    line02: {
      title: '易博通APP有哪幾種撥號方式',
      content1: '',
      content2: ''
    },
    line03: {
      title: '易博通號碼收發短信的規則是怎樣的？',
      content1: '',
      content2: ''
    },
    line04: {
      title: '如何設置易博通APP系統權限',
      content1: '以華為品牌手機為例，如下圖：',
      content2: ''
    },
    line05: {
      title: '如何設置易博通APP後台運行？',
      content1: '',
      content2: ''
    },
    line06: {
      title: '來電的時候，只聽到鈴聲，看不到接聽界面，如何設置？',
      content1: '手機通知權限設置裡面所有能打開的權限全部打開【給予】，具體設置請參考手機說明書。',
      content2: ''
    },
    line07: {
      title: '如何查看已經辦理的號碼信息？',
      content1: '點擊「個人」->「我的產品」',
      content2: ''
    },
    line08: {
      title: '發送短信時，出現「不正確的目的號碼」，如何處理？',
      content1: '可能的原因是發送號碼選擇了易博通大陸號碼，或者接收號碼是大陸移動號碼，具體請參考第3點：易博通號碼收發短信規則。',
      content2: ''
    },
    line09: {
      title: '撥打電話時，出現閃斷或者沒反應，如何解決？',
      content1: '可能的原因是沒有選擇正確的主叫號碼或者是錯誤的撥號方式，比如：主叫號碼是易博通香港號碼，但撥號時，沒有輸入正確的區號，具體請參考第2點：易博通APP撥號方式',
      content2: ''
    },
    line10: {
      title: '別人撥打我易博通號碼時，無法撥通，如何解決？',
      content1: '可能的原因是易博通APP已經退出，請重新啓動APP即可，如想保持APP一直在線狀態，請在手機系統中設置APP後台運行權限，具體設置請參考第5點：設置易博通APP後台運行；',
      content2: ''
    },
    line11: {
      title: '電話接通時，對方聽不到我說話或者我聽不到對方說話，如何解決？',
      content1: '1）可能的原因是當前的網絡信號不好，請使用WI-FI或者移動到網絡好的地方再嘗試',
      content2: '2）也有可能是手機的安全軟件禁止易博通APP聯網，請檢查安全軟件的設置，可以把易博通APP放入到安全軟件的白名單中；'
    },
    line12: {
      title: 'APP升級後，每次打開APP時都需要重新登錄，如何解決？',
      content1: '請關閉易博通APP進程後，重新登錄APP即可解決；',
      content2: ''
    },
    line13: {
      title: '登錄時，出現登錄異常界面，如何處理？',
      content1: '方法1: 檢查手機的網絡設置是否正常， 或者手機信號是否正常；',
      content2: '方法2: 如果方法1無法解決，請按照界面提示進行報障；'
    },
    line14: {
      title: '手機通知欄中看到短信通知信息，但進入APP後看不到該條短信？',
      content1: '估計是版本衝突造成的，請先卸載現有的APP版本，然後重新安裝APP。',
      content2: ''
    }
  },
  feedback: {
    head: '我要反饋',
    title: '在您使用過程中，如有出現使用不順暢的地方，請向我們反饋意見，幫助易博通產品不斷改進。',
    time: '發生時間',
    year: '年',
    month: '月',
    day: '日',
    type: '問題類型',
    selectType: '請選擇問題類型',
    cancle: '取消',
    sure: '確定',
    view: '問題表現',
    selectView: '請選擇問題表現',
    net: '網絡方式',
    selectNet: '請選擇網絡方式',
    region: '所在地區',
    inputRegion: '請輸入所在地區',
    desc: '補充說明',
    descTip: '最多200字',
    contactInfo: '聯絡電郵',
    inputContactInfo: '請輸入聯絡電郵',
    inputFailContactInfo: '電郵地址格式不正確',
    submit: '提交反饋',
    success: '您的反饋已經提交',
    fail: '提交失敗',
    feedbackType: [{
      TYPE_ID: '1',
      TYPE_SORT: '1',
      TYPE_NAME: '網絡問題'
    },
    {
      TYPE_ID: '2',
      TYPE_SORT: '2',
      TYPE_NAME: '權限問題'
    }
    ],
    networkInfo: [{
      NETWORK_ID: '1',
      TYPE_SORT: '1',
      NETWORK_NAME: 'WIFI'
    },
    {
      NETWORK_ID: '2',
      TYPE_SORT: '2',
      NETWORK_NAME: '3G'
    },
    {
      NETWORK_ID: '3',
      TYPE_SORT: '3',
      NETWORK_NAME: '4G'
    }
    ],
    feedbackDetail: [{
      TYPE_ID: '1',
      DETAIL_ID: '1',
      TYPE_SORT: '1',
      DETAIL_NAME: '斷斷續續'
    },
    {
      TYPE_ID: '1',
      DETAIL_ID: '2',
      TYPE_SORT: '2',
      DETAIL_NAME: '聲音模糊'
    },
    {
      TYPE_ID: '2',
      DETAIL_ID: '3',
      TYPE_SORT: '3',
      DETAIL_NAME: '出錯'
    },
    {
      TYPE_ID: '2',
      DETAIL_ID: '4',
      TYPE_SORT: '4',
      DETAIL_NAME: '體驗差'
    }
    ]
  },
  realNameVerify: {
    head: '實名登記',
    idType: '證件類別',
    hkId: '香港身份證',
    cnId: '中華人民共和國居民身份證',
    upLoadFacePic: '上傳證件正面照片',
    upLoadBackPic: '上傳證件背面照片',
    upLoadTips: '請使用身份證明文件之正本進行實名登記。 照片需避免阻礙物或反光。',
    scan: '掃描',
    notice: '請輸入與身份證明文件相同的資料。',
    idInputTitle: '證件號碼',
    enNameInputTitle: '英文全名',
    nameIputTitle: '中文全名',
    finishBtn: '完成',
    success: '成功登記',
    fail: '登記失敗',
    confirm: '確定',
    successTips: '閣下已經成功完成實名登記手續，我們將於半至 1 小時內進行資料審核，審核結果會發送到閣下所填報之電子郵箱內。如有任何問題請與我們聯絡，謝謝！',
    errorTips: {
      idNo: '請輸入證件號碼',
      enName: '請輸入英文全名',
      name: '請輸入中文全名',
      idFrontPic: '請上傳證件正面照片',
      idBackPic: '請上傳證件背面照片'
    }
  },
  business: {
    provision: {
      title: '中國香港手機號登記',
      registerErr: '預註冊香港號碼失敗,請於10分鐘後再試！',
      registerOk: '預註冊香港號碼成功',
      plan: {
        title: '香港免 SIM 卡服務',
        content: '無SIM卡，App收取短信，App接聽撥打電話。App端單獨購買的號碼，不能在微信收取短信。',
        selectTip: '請選擇你的計劃.....',
        tip: '請先選擇套餐',
        warn: '獲取可選套餐列表失敗'
      },
      number: {
        title: '選擇心儀號碼.....',
        content: '換一批號碼',
        selectTip: '(只能換一次)',
        tip: '請先選擇號碼',
        warn: '獲取可登記香港號碼列表失敗',
        tipTitle: '無法開通手機號',
        tipContent: '你的申請已達到上限，每個帳戶最多可以申請 2 個中國香港手機號及 1 個中國内地手機號。'
      },
      member: {
        title: '香港免 SIM 卡服務',
        content: '香港特區政府於2021年6月1日公佈訂立《電訊（登記用戶識別卡）規例》，並於同年9月1日實施，以落實電話智能卡實名登記制度，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。',
        userlabel: '客戶資料',
        userTip: '輸入姓名',
        userWarn: '請輸入姓名',
        mobileTip: '輸入聯絡電話',
        mobileWarn: '請輸入正確的手機號碼',
        codeLabel: '優惠碼',
        codeTip: '優惠碼（如有）',
        codeWarn: '請輸入正確的優惠碼',
        codeOk1: '成功使用，已額外獲取 ',
        codeOk2: ' 天有效期',
        useCodeTip: '優惠碼無效，是否繼續購買?',
        useBut: '繼續',
        cancleUseBut: '取消',
        mobilePrefixTitle: '選擇電話區號',
        mobilePrefixList: [
          {name: '中國香港（+852）', value: '852'},
          {name: '中國内地（+86）', value: '86'},
          {name: '中國澳門（+853）', value: '853'},
          {name: '中國台灣（+886）', value: '886'},
          {name: '美國 / 加拿大（+1）', value: '1'},
          {name: '英國（+44）', value: '44'},
          {name: '馬來西亞（+60）', value: '60'},
          {name: '澳洲（+61）', value: '61'},
          {name: '菲律賓（+63）', value: '63'},
          {name: '印尼（+62）', value: '62'},
          {name: '新加坡（+65）', value: '65'},
          {name: '泰國（+66）', value: '66'},
          {name: '日本（+81）', value: '81'},
          {name: '韓國（+82）', value: '82'},
          {name: '越南（+84）', value: '84'},
          {name: '法國（+33）', value: '33'},
          {name: '意大利（+39）', value: '39'},
          {name: '德國（+49）', value: '49'},
          {name: '其他', value: ''}
        ]
      },
      confirm: {
        title: '確認訂單',
        tetle2: '香港免 SIM 卡服務',
        code: '優惠碼',
        price: '總額',
        plan: '計劃號碼',
        username: '輸入姓名',
        mobile: '聯絡電話',
        add: '加',
        day: '天有效期',
        update: '修改'
      },
      letter: {
        title: '「易博通」服務計劃同意書（香港號碼）',
        statement: '個人聲明',
        statementInfo: '我已經閱讀和了解廣州博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條「收集個人資料」的規定，請在以下適當空格加上「√」號：',
        statementDetail1: '本人同意以上條款及細則。',
        statementDetail4: '本人同意博元使用本人的個人資料直接促銷任何服務產品。',
        statementDetail2: '本人同意博元使用本人的個人資料，但僅限於延續服務安排及由博元直接提供的電訊服務 (包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
        statementDetail3: '本人不同意博元使用任何本人的個人資料促銷用途。',
        content: [
          '以上服務提供於「易博通eSender」微信公眾號及/或易博通APP綁定香港號碼查閱及發送短訊服務。廣州博元訊息科技有限公司 (「博元」) 亦可提供實體智能卡予客戶攜號轉台或使用話音﹑數據及手機發送短訊服務，唯客戶需要繳付智能卡費用及／或速遞費用 (如適用)。話音﹑數據及手機發送短服務需另行收費。',
          '於易博通微信公眾號及/或易博通APP發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽博元網頁 www.multi-byte.com 或本公眾號。',
          '當服務有效期屆滿前，博元將發送訊息予客戶登記之香港號碼提示客戶，客戶可於已於綁定香港號碼的易博通微信公眾號及/或易博通APP查閱，並可於效期屆滿前自行於易博通微信公眾號﹑易博通APP或博元網頁www.multi-byte.com 繳費以延長服務有效期。',
          '當服務有效期完結時，服務會被暫停。客戶可於易博通微信公眾號﹑易博通APP或博元網繳費並重啟服務。暫停期間之訊息將不獲補發。',
          '如服務因任何原故而停用超過 3 日或終止服務，客戶同意屆時必須放棄該分配的香港號碼並歸還予博元。',
          '服務計劃中的香港號碼不能更改。',
          '如服務因任何原故而停用，所預繳之費用將不獲退還。',
          '任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品。',
          '根據香港《電訊 (登記用戶識別卡) 規例》落實電話智能卡實名登記制度的實施安排，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。申請香港流動電話號碼必須實名登記，個人用戶須提供身分證明文件 (香港身份證或其他可接受的身分證明文件如旅客的"旅遊證件") 內的資料，包括姓名、出生日期和身分證明文件號碼及其照片，以作登記。若公司或企業要登記成為電話智能卡用戶，則須提供其商業登記資料及指定某人士作為代表或負責人，並提供該名人士的個人資料。16歲以下人士如需登記電話智能卡服務，相關登記必須得到一位成人的確認，電訊商亦會登記該名成人的資料。如閣下不提供個人資料，閣下將無法開通使用或繼續使用涉及香港流動電話號碼的電訊通訊服務，詳情請瀏覽博元網頁www.multi-byte.com。',
          '此服務受廣州博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁。',
          '上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申請之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途。',
          '廣州博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束。'
        ],
        warn: '請同意有關條款'
      },
      paySuccess: {
        hknum: '香港號碼'
      }
    }
  },
  tokenFail: {
    title: '提示',
    msg: '登入會話已過期，請重新登入！',
    confirm: '確定'
  },
  ordinaryNum: {
    head: '中國內地手機號',
    title: '中國內地手機號碼登記',
    topTips: '鑒於中國內地政府推行的流動電話號碼實名登記政策，所有中國內地號碼用戶必須通過實名登記方能開通、使用或繼續使用中國內地號碼。每人只可以申請一個中國流動電話號碼，登記可免費使用七天，如七天用完後想保留該號碼繼續使用，可付費充值。',
    title2: '確認訂單',
    topTips2: '每人只可以申請一個中國流動電話號碼，登記可免費使用七天，如七天用完後想保留該號碼繼續使用，可付費充值繼續使用。',
    custInfo: '客戶資料',
    idInfo: '證件類型',
    inputTips: {
      idType: '選擇證件類型...',
      phone: '輸入聯絡電話',
      idName: '輸入姓名（與證件名字相同）',
      idNum: '輸入證件號碼',
      idFormat: '輸入格式：AXXXXXXX',
      phoneNeed11: '請輸入11位電話號碼',
      phoneNeed8: '請輸入8位電話號碼',
      needHKId: '請輸入有效的香港身份證',
      needCNId: '請輸入有效的中國內地身份證'
    },
    confirm: {
      idName: '客戶姓名',
      phone: '聯絡電話',
      idType: '證件類型',
      idNum: '證件號碼'
    },
    idType: {
      CN: '中國內地身份證',
      CP: '中華人民共和國護照',
      FC: '外國人永久居留身份證',
      HK: '香港身份證',
      HM: '港澳居民來往內地通行證',
      MC: '澳門身份證',
      PP: '護照',
      RC: '國內居住證',
      TW: '台胞證'
    },
    btn: {
      back: '返回',
      next: '下一步',
      update: '修改',
      goToCharge: '結餘充值',
      backIndex: '返回主頁'
    },
    success: '成功申請',
    fail: '登記失敗',
    successTitle: '中國內地號碼',
    successTips: '恭喜！閣下已經成功申請中國大陸手機號免費體驗七天！我們提供多款套餐供您訂購，訂購期內無限接收短信。如七天用完後想保留該號碼繼續使用，可付費充值繼續使用。開始使用服務前，閣下必須前往“易博通 eSender” 微信公眾號進行實名登記。請閣下準備好登記號碼的證件資料及個人半身實況照片。',
    letter: {
      title: '「易博通」服務計劃同意書（中國內地號碼）',
      statement: '個人聲明',
      statementInfo: '我已經閱讀及瞭解廣州博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條“收集個人資料”的規定，請在以下適當空格加上「√」號：',
      statementDetail1: '本人同意以上條款及細則。',
      statementDetail4: '本人同意博元使用本人的個人資料直接促銷任何服務產品。',
      statementDetail2: '本人同意博元使用本人的個人資料，但僅限於延續服務安排及由博元直接提供的電訊服務 (包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
      statementDetail3: '本人不同意博元使用任何本人的個人資料促銷用途。',
      content: [
        '此服務提供於易博通微信公眾號及/或易博通APP綁定中國內地號碼查閱及發送短訊服務，發送短服務需另行收費。',
        '當服務有效期屆滿前，廣州博元訊息科技有限公司 (「博元」) 將發送訊息予客戶登記之中國內地號碼提示客戶，客戶可於已於綁定中國內地號碼的易博通微信公眾號及/或易博通APP查閱，並可於效期屆滿前前自行於易博通微信公眾號﹑易博通APP或博元網頁www.multi-byte.com繳費以延長服務有效期。',
        '當服務有效期完結時，服務會被暫停。客戶可於易博通微信公眾號及/或易博通APP或博元網頁繳費並重啟服務。暫停期間之訊息將不獲補發。',
        '如服務因任何原故而停用超過15日或終止服務，客戶同意屆時必須放棄該分配的中國內地號碼並歸還予博元。',
        '服務計劃中的中國內地號碼不能更改。',
        '服務計劃中的中國內地號碼祇適用於「易博通」服務。',
        '如服務因任何原故而停用，所預繳之費用將不獲退還。',
        '任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品。',
        '中華人民共和國工業和信息部文件《電話用戶真實身份信息登記實施規範》，申請中國內地流動電話號碼必須實名登記，實名登記的年齡範圍必須在16歲以上。博元須向閣下搜集閣下的個人資料，包括姓名、流動電話號碼、聯絡方法﹑港澳身份證﹑台灣居民來往大陸通行證、中國公民身份證、護照或其它身份證明文件﹑免冠相片及自拍影片的資料等 (「上述資料」)，以協助閣下向中國內地當局辦理實名登記 (「上述登記」)。上述資料會按中國內地政府推行的流動電話號碼實名登記政策有所更改。閣下沒有義務向博元提供上述資料，但如閣下不提供個人資料，中國內地當局會按相關政策指令停止閣下的中國內地號碼服務，閣下將無法開通使用或繼續使用涉及中國內地流動電話號碼的電訊通訊服務，詳情請瀏覽博元網頁www.multi-byte.com。',
        '用戶如有虛假交易的行為﹑以轉售或詐騙為目的使用本服務，博元有權在無任何補償或事先通知情況下，終止閣下的中國內地號碼服務。',
        '用戶不得將易博通服務用於電信資訊網路詐騙及其他違法行為，如出現電話詐騙、網路詐騙、垃圾短信投訴情況，博元有權在無任何補償或事先通知情況下，永久終止閣下的易博通號碼。',
        '此服務受廣州博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁www.multi-byte.com。',
        '上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申請之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途。',
        '廣州博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束。'
      ],
      warn: '請同意有關條款'
    }
  },
  buyRecord: {
    head: '交易紀錄',
    number: '號碼',
    plan: '計劃',
    productType: '產品類型',
    orderTime: '交易時間',
    orderAmount: '交易金額',
    orderPayType: '交易方式',
    orderSn: '參考編號',
    noData: '您還沒有訂單'
  },
  addPackagePlan: {
    head: '加購計劃',
    choosePlan: '請選擇套餐'
  },
  smartSIMHK: {
    head: '實體智能卡',
    subTitle: '包括：實體 SIM 卡、 4G 數據、通話分鐘、收取短訊',
    choosePlan: '請選擇你的計劃.....',
    planTips: '熱門優選套餐',
    expressTips: '選擇速遞地區及收費',
    shippingAddressTips: '輸入收貨地址',
    expressArea: {
      china: '中國內地',
      hk: '香港',
      taiwan: '台湾',
      macao: '澳門',
      malaysia: '馬來西亞',
      singapore: '新加坡'
    },
    expressWarn: '請選擇速遞地區及收費',
    addressWarn: '請輸入收貨地址',
    regTitle: '實體智能卡登記',
    regTips: '香港特區政府於2021年6月1日公布訂立《電訊（登記用戶識別卡）規例》，並於同年9月1日實施，以落實電話智能卡實名登記制度，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。',
    expressFee: '速遞費用',
    consigneeDistrict: '速遞地區',
    consigneeAddress: '收貨地址',
    successTips: '恭喜！閣下已經成功購買套餐。實體智能卡會於 7 天工作日內按排寄出。寄出後會已電郵通知您。 感謝閣下使用易博通服務！'
  },
  specialCnNumber: {
    head: '特選號碼',
    subTitle: '請輸入您的心儀號碼',
    fixedSection: '固定號碼段',
    favoriteNumber: '心儀號碼',
    find: '查找',
    notFindWarn: '找不到相關號碼，請重新輸入。',
    own: '可享',
    regTitle: '特選號碼登記',
    regTips: '鑒於中國內地政府推行的流動電話號碼實名登記政策，所有中國內地號碼用戶必須通過實名登記方能開通、使用或繼續使用中國內地號碼。每人只可以申請一個中國流動電話號碼， 成功登記後可付費充值開啟服務。',
    successTips1: '恭喜閣下已經成功申請易博通中國內地手機號， 如需要發出短信及通話，您可前往易博通微信公眾號付費充值，你的號碼亦可升級登記成為實體智能咭。 ',
    successTips2: '根據中國工信都相關條例，中國內地手機號必須實名認證後才可使用服務，請前往易博通微信公眾號進行登記。'
  },
  ukPlan: {
    title: '英國手機號登記',
    registerErr: '預註冊英國號碼失敗',
    registerOk: '預註冊英國號碼成功',
    plan: {
      title: '英國手機號',
      content: '無 SIM 卡，微信和 App 收取短訊',
      selectTip: '請選擇你的計劃.....',
      tip: '請先選擇套餐',
      warn: '暫無套餐可供銷售'
    },
    number: {
      title: '選擇心儀號碼.....',
      content: '換一批號碼',
      selectTip: '(只能換一次)',
      tip: '請先選擇號碼',
      warn: '獲取可登記英國號碼列表失敗',
      tipTitle: '無法開通手機號',
      tipContent: '你的申請已達到上限，每個帳戶最多可以申請 1 個英國手機號。'
    },
    member: {
      title: '英國手機號',
      content: '此英國手機號套餐計劃為無 SIM卡計劃，計劃只限於 APP或微信內收短訊使用。（計劃並不包括通話、 發短訊和數據功能）',
      userlabel: '客戶資料',
      userTip: '輸入姓名',
      userWarn: '請輸入姓名',
      mobileTip: '輸入聯絡電話',
      mobileWarn: '請輸入正確的手機號碼',
      codeLabel: '優惠碼',
      codeTip: '優惠碼（如有）',
      codeTip2: '輸入優惠碼後， 在成功開通後可額外增加15日。',
      codeWarn: '請輸入正確的優惠碼',
      codeOk1: '成功使用，已額外獲取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '優惠碼無效，是否繼續購買?',
      useBut: '繼續',
      cancleUseBut: '取消',
      mobilePrefixTitle: '選擇電話區號',
      mobilePrefixList: [
        {name: '中國香港（+852）', value: '852'},
        {name: '中國内地（+86）', value: '86'},
        {name: '中國澳門（+853）', value: '853'},
        {name: '中國台灣（+886）', value: '886'},
        {name: '美國 / 加拿大（+1）', value: '1'},
        {name: '英國（+44）', value: '44'},
        {name: '馬來西亞（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律賓（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰國（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韓國（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法國（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德國（+49）', value: '49'},
        {name: '其他', value: ''}
      ]
    },
    confirm: {
      title: '確認訂單',
      tetle2: '英國手機號',
      code: '優惠碼',
      price: '總額',
      plan: '計劃號碼',
      username: '輸入姓名',
      mobile: '聯絡電話',
      add: '加',
      day: '天有效期',
      update: '修改'
    },
    letter: {
      title: '「易博通香港eSender HK」服務計劃同意書（英國號碼）',
      statement: '個人聲明',
      statementInfo: '我已經閱讀和了解廣州博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條「收集個人資料」的規定，請在以下適當空格加上「√」號：',
      statementDetail1: '本人同意以上條款及細則。',
      statementDetail4: '本人同意博元使用本人的個人資料直接促銷任何服務產品。',
      statementDetail2: '本人同意博元使用本人的個人資料，但僅限於延續服務安排及由博元直接提供的電訊服務 (包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
      statementDetail3: '本人不同意博元使用任何本人的個人資料促銷用途。',
      content: [
        '以上服務提供於微信「易博通香港 eSender HK」公眾號綁定英國號碼查閱短訊服務。',
        '當服務有效期屆滿前，博元將發送訊息提示給予已登記英國號碼的客戶，客戶可於已於綁定英國號碼的微信「易博通香港eSenderHK」之公眾號查閱，並可於有效期屆滿前自行在本公眾號繳費以延長服務有效期。',
        '當服務有效期完結時，服務會被暫停。客戶可於微信「易博通香港 eSender HK」公眾號繳費並重啟服務。暫停期間之訊息將不會補發。',
        '如服務因任何原故而停用超過3日或終止服務，客戶必須同意放棄該分配的英國號碼，並歸還予博元。',
        '服務計劃中嘅英國號碼將不能更改。',
        '如服務因任何原故而停用，所預繳之費用將不獲退還。',
        '任何優惠不得自由轉讓、退回現金及/或不可兌換其他服務及/或產品。',
        '此服務受博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁。 ',
        '上述資料為閣下自願提供，如資料有錯漏，博元訊息可能未能為閣下提供所申請之服務。博元訊息有權使用上述資料為閣下提供服務或通知閣下優惠推廣活動。如有需要，將披露予第三方作信用覆核、追討債務、市場研究、及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途。',
        '博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，如有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束。'
      ],
      warn: '請同意有關條款'
    }
  },
  traveleSimPlan: {
    head: '訂購 eSIM',
    title: '訂購 eSIM',
    tips1: '1. eSIM 計劃不包括通話及收取短訊功能',
    tips2: '2. 每個帳戶最多可以申請 5 張 eSIM',
    tips3: '3. 訂購 eSIM 需額外支付 HK$20 登記費',
    moreEsim: '了解eSIM >',
    chooseArea: '請選擇國家...',
    registerErr: '訂購 eSIM失敗',
    registerOk: '訂購 eSIM成功',
    areaWarn: '獲取地區列表失敗',
    searchTips: '找尋目的地...',
    hotTips: '熱門目的地',
    areaTips: '地區分類',
    buy: '購買',
    noData: '沒有搜索結果',
    noSearchArea: '找不到相關國家/地區...',
    ApplicableTo: '適用於',
    Details: '詳情',
    Description: '產品說明',
    Instructions: '產品須知',
    plan: {
      tips1: '1. eSIM 計劃不包括通話及收取短訊功能 ',
      tips2: '2. 每個帳戶最多可以申請 5 張 eSIM ',
      tips3: '3. 訂購 eSIM 需額外支付 HK$20 登記費 ',
      tips4: '4. FUP：當資料流程量達到上述公平使用量(FUP)時， 資料傳輸速度將會被降至不低於 128kbps ',
      tips5: '5. 除非特別標明 “ * ”，所有網絡均為4G，標明 “ * ” 之 地區，網絡均為3G',
      selectTip: '請選擇你的計劃.....',
      tip: '請先選擇套餐',
      warn: '獲取可選套餐列表失敗'
    },
    member: {
      title: '英國免 SIM 卡服務',
      content: '香港特區政府於2021年6月1日公佈訂立《電訊（登記用戶識別卡）規例》，並於同年9月1日實施，以落實電話智能卡實名登記制度，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。',
      userlabel: '客戶資料',
      emailTip: '輸入正確的电邮',
      emailWarn: '請輸入正確的电邮',
      reEmailTip: '輸入正確的確認電郵地址',
      reEmailWarn: '請輸入正確的確認電郵地址',
      codeLabel: '優惠碼',
      codeTip: '優惠碼（如有）',
      codeWarn: '請輸入正確的優惠碼',
      codeOk1: '成功使用，已額外獲取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '優惠碼無效，是否繼續購買?',
      useBut: '繼續',
      cancleUseBut: '取消',
      mobileTypeTips: '選擇手機型號...',
      mobileTypeWarn: '請選擇手機型號'
    },
    confirm: {
      title: '確認訂單',
      code: '優惠碼',
      price: '總額',
      plan: '計劃號碼',
      username: '輸入姓名',
      mobile: '聯絡電話',
      add: '加',
      day: '天有效期',
      regPrice: 'eSIM 登記費',
      update: '修改',
      tips: '*eSIM 確認電郵將於大約 5 分鐘內傳送到閣下提供的電郵中。',
      email: '電郵地址'
    },
    letter: {
      title: '「易博通香港eSender HK」服務計劃同意書（eSIM）',
      statement: '個人聲明',
      statementInfo: '我已經閱讀和了解廣州博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條「收集個人資料」的規定，請在以下適當空格加上「√」號：',
      statementDetail1: '本人同意以上條款及細則。',
      statementDetail4: '本人同意博元使用本人的個人資料直接促銷任何服務產品。',
      statementDetail2: '本人同意博元使用本人的個人資料，但僅限於延續服務安排及由博元直接提供的電訊服務 (包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
      statementDetail3: '本人不同意博元使用任何本人的個人資料促銷用途。',
      content: [
        '現有易博通用戶，無論是否開通有效的香港號碼或中國號碼，均可登記旅遊eSIM。',
        '除非特別說明，旅遊eSIM使用網路網路均為4G。',
        '每個微信帳號只限同時購買不多於三張易博通旅遊eSIM。',
        '旅遊eSIM 帳戶和易博通香港號碼帳戶/易博通中國號碼帳戶(如有)完全獨立，沒有任何關聯。',
        '旅遊eSIM提供數據上網服務，話音及短訊服務並不適用，並不配有任何香港或中國號碼。',
        '客户手機必須支援eSIM功能, 並必須於手機開啟數據漫遊，可以流覽各種社交網路，隨插即用，不需實名登記。',
        '用戶必須於購買旅遊eSIM起60天內啟動旅遊eSIM，逾期無效。',
        '服務有效期為啟動當日起計算，每天00:00至23:59(均以北京時間為準)為一天使用時間，到期後數據服務將會暫停。 ',
        'Fair Usage Policy(FUP):當每天數據用量達套餐的公平使用量(FUP)時，數據傳輸速度將會被降至不低於128kbps; 高速數據傳輸速度將於第二天凌晨恢復。',
        '用戶可於旅遊eSIM啟動後有效期內或到期後七日內即時充值延長天數以繼續使用該旅遊eSIM，到期日後七日如未充值，該旅遊eSIM將會被終止。',
        '網絡速度受多種因素影響，包括但不限於覆蓋﹑客戶器材﹑位置﹑網絡設及流量情況等等。',
        '如客戶身處4G覆蓋以外地區，博元仍會透過3G/2G/EDGE 網絡為客戶提供服務。',
        '以上內容如有任何更改，恕不另行通知。博元訊息科技有限公司保留隨時更改或終止以上條款的權利。'
      ],
      warn: '請同意有關條款'
    }
  },
  myProduct: {
    head: '我的手機號',
    menu: {
      all: '所有手機號',
      hk: '香港號碼',
      cn: '內地號碼',
      eSim: 'eSim',
      ext: '國外號碼'
    },
    normal: '正常',
    effective: '生效中',
    invalid: '已無效',
    active: '生效',
    planExpired: '套餐過期',
    expired: '過期',
    expiredNoBalance: '到期/沒有結餘',
    toBeRecycle: '號碼即將回收',
    realName: '實名登記',
    notRealName: '未實名',
    addPlan: '加購套餐',
    balance: '餘額',
    status: '狀態',
    dueDate: '到期日',
    deadline: '激活限期',
    update: '更新',
    addPlanTips: '* 請於 *XX 天內加購套餐，否則號碼將被取消。',
    realNameTips: '* 未有做實名登記，其短訊將無法送達。',
    activation: '激活',
    notActive: '未激活',
    isDel: '已刪除',
    warn: '获取我的產品列表失败',
    notApplicable: '不適用',
    usedData: '已使用數據',
    typeInfo90: ['普通手機號碼', '1.中國內地普通手機號計劃為無 SIM卡計劃，計劃只限於 APP 內收短訊及接聽撥打電話使用。（計劃並不包括數據功能）', '2. * 每人只可以申請 1 個中國内地手機號並且必須通過電話智能卡實名登記後才可以使用。'],
    typeInfo91: ['免 SIM卡服務', '1.香港免 SIM卡套餐計劃為無 SIM卡計劃，計劃只限於  APP 內收短訊及接聽撥打電話使用。（計劃並不包括數據功能）', '2. * 中國香港號碼必須通過電話智能卡實名登記後才可以使用。'],
    typeInfo92: ['eSIM 服務', '1. eSIM 計劃不包括通話及收取短訊功能。', '2. 網絡：當數據用量達到適用於該客戶之公平使用數據用量上限，資料傳輸速度將會被降至不低於 128kbps。'],
    typeInfo93: ['臺灣號碼服務', '臺灣套餐計劃為無 SIM卡計劃，計劃只限於 eSender APP 或微信內收短訊使用。（計劃並不包括通話、 發短訊和數據功能）'],
    typeInfo94: ['美國號碼服務', '美國套餐計劃為無 SIM卡計劃，計劃只限於 eSender APP 或微信內收短訊使用。（計劃並不包括通話、 發短訊和數據功能）'],
    typeInfo95: ['英國號碼服務', '英國套餐計劃為無 SIM卡計劃，計劃只限於 eSender APP 或微信內收短訊使用。（計劃並不包括通話、 發短訊和數據功能）'],
    typeInfo96: ['馬來西亞號碼服務', '馬來西亞套餐計劃為無 SIM卡計劃，計劃只限於 eSender APP 或微信內收短訊使用。（計劃並不包括通話、 發短訊和數據功能）']
  },
  eSimTopUp: {
    head: 'eSIM 充值',
    choosESIM: '選擇 eSIM',
    choosPlan: '請選擇套餐',
    topUp: '充值',
    update: '更新',
    registerErr: 'eSIM 充值失敗',
    getListWarn: '獲取eSIM 充值列表失敗',
    noData: '沒有可以充值的 eSIM'
  },
  contactUs: {
    t1: '博元微信公眾號',
    tips1: '1. 儲存二維碼到手機，啟動微信應用程式',
    tips2: '2. 按畫面按右上方的「+」，再按「掃描」並打開相簿點選已儲存的QR Code',
    tips3: '3. 掃描後進入「博元訊息」官方帳戶，按「關注」即可瀏覽',
    btn: '儲存二維碼'
  },
  gs: {
    payment: {
      redemSuccess: '兌換成功',
      redemFail: '兌換失敗',
      confirm: '確認'
    },
    rate: {
      title: ' Travel Call IDD收費表',
      searchNoResult: '無結果',
      searchTip: '搜索',
      tableTitleLeft: '國家 / 地區',
      tableTitleCenter: '區號',
      tableTitleRight: '收費',
      tableTitleRightUnit: '(HKD/分鐘)',
      cancel: '取消',
      tipTitle: '溫馨說明',
      tip1: '1. 以下收費以港幣為單位；所有收費以每分鐘計算，不足一分鐘亦作一分鐘計算。',
      tip2: '2. 香港號碼長途電話服務需另外計算香港/中港通話分鐘或香港/中港通話分鐘收費。',
      tip3: '3. 阿東基有限公司 保留對以下優惠條款及細則之最終決定權。收費如有更改恕不另行通知。'
    },
    company: {
      title: '關於阿東基',
      ERCodeDesc: '阿東基 (ADONKILIMITED)',
      info: '阿東基(adonkilimited)為一家專營全球各地上網卡 數據卡 電話卡專門店 設24小時網購平台,免費平郵、全港順豐站及工商業地址快遞等寄取服務，我們提供免費專人whatsapp技術支援，我們的宗旨幫你以最抵價格買到心水產品。',
      gotoMB: '前往網站'
    },
    privacyText: {
      title: ' Travel Call隱私政策',
      summary:
        {
          title: '摘要',
          text: '阿東基有限公司。（「 Travel Call」或「我們」或「我們的」或「我們的」或其他類似代詞）非常重視您的隱私問題。請閱讀以下內容，以瞭解有關我們的隱私政策（「政策」）的更多信息。本政策詳細說明瞭我們如何接收，收集和使用Travel Call軟件上提供服務有關的信息。 （以上統稱為「服務」）。使用本服務時，即表示您接受本政策中所述的政策和慣例，因為該政策可能會不時進行修改。每次您使用服務時，即表示您同意並明確同意我們按照本政策的規定收集，使用和披露您提供的信息。'
        },
      one: {
        title: '一.我們會收集閣下的哪些資訊？',
        text1: '若閣下設定Travel Call  帳戶，並使用Travel Call提供的服務，我們將會收集閣下的資訊。我們會收集閣下的',
        text2: '設備型號、操作系統、位置信息、手機讀寫、麥克風、通訊錄、攝像頭、唯一設備標識符、登錄IP地址、接入網絡的方式、類型和狀態、網絡質量數據、操作日誌、暱稱、手機號碼以及通話和短信記錄',
        text3: '，這些信息是為提供服務必須收集的基礎信息。同時閣下可以提供更多資訊，讓閣下的個人資料更精細與受歡迎，所收集到的信息我們將妥善存儲和謹慎使用。'
      },
      two: {
        title: '二.第三方SDK目錄',
        substile1: '1) 極光(Jiguang)推送SDK，为 APP 用户提供信息推送服务',
        text2: 'A.獲取權限：',
        text3: '•獲取您的設備信息,包括IMEI、IDFA、Android ID、GAID、MAC、OAID、IMSI、MEID、UAID）：用於生成脫敏的終端用戶設備唯一性標識，以確保能準確進行消息推送，用於用戶操作行為記錄；',
        text4: '•獲取您的讀寫外部存儲（包括設備型號、設備屏幕分辨率、設備硬件製造商、設備產品名稱）：用於保證服務在不同設備上的兼容性，確保消息準確下發；',
        text5: '•查看您的網絡鏈接狀態 （包括網絡類型、運營商名稱、基站信息、IP地址、WiFi信息、SSID、BSSID）：用於判斷SDK與服務器的網絡連接狀態，保證服務的穩定性和連續性；',
        text6: 'B.使用目的',
        text7: '•推送消息,用於您查詢推送服務記錄，瞭解推送信息送達的情況。',
        text8: 'C.處理方式',
        text9: '•採用替換，去標識，加密，匿名化方式對個人信息進行脫敏展示',
        text10: 'D.極光隱私協議',
        subtitle2: '2)友盟UShare SDK',
        text20: '為了向閣下提供一鍵分享服務，我們的產品集成友盟+ Ushare SDK，友盟Ushare SDK需要收集閣下的 設備Mac地址、唯一設備識別碼（IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息）以及閣下需要分享的社交賬號公開信息，以便完成一鍵分享服務。並通過地理位置校准報表數據準確性，提供基礎反作弊服務。為了閣下的信息安全，我們已與第三方SDK服務商進行數據安全保密約定，這些公司會嚴格遵守我們的數據隱私和安全要求。\n' +
          '        除非得到閣下的同意，我們不會與其共享閣下的個人身份信息。為便於閣下更好地瞭解【友盟+】採集的數據類型及用途，以及何保護閣下的個人信息.',
        text21: '閣下可以登陸',
        text22: '瞭解【友盟+】隱私權政策 .',
        subtitle3: '3) 騰訊Bugly SDK',
        text30: '為了更好排查崩潰問題,幫助APP提升穩定性，我們的產品集成了騰訊Bugly SDK，騰訊Bugly SDK需要收集Android系統版本，廠商系統版本，內存空間佔用大小等信息，為了閣下的信息安全，我們已與第三方SDK服務商進行數據安全保密約定，這些公司會嚴格遵守我們的數據隱私和安全要求。 除非得到閣下的同意，我們不會與其共享閣下的個人身份信息。為便於閣下更好地瞭解【Bugly SDK】採集的數據類型及用途，以及何保護閣下的個人信息.',
        text31: '閣下可以訪問 ',
        text32: ', 瞭解Bugly SDK隱私保護聲明.'
      },
      three: {
        title: '三.我們會如何使用閣下的資訊？',
        text1: '我們會使用閣下的資訊來提供閣下的 Travel Call 服務，允許閣下與其他使用者通訊，以及使用 Travel Call 公開平台的功能。我們會使用閣下的資訊來設定帳戶、促進通訊、提供支援、允許閣下存取 Travel Call 功能，並改善 Travel Call 服務。 Travel Call 會使用閣下所使用的WeChat應用，以驗證及保護閣下的帳戶，也會為重要管理因素而使用，且 Travel Call 不會將這些聯絡管道用於推銷或行銷。'
      },
      four: {
        title: '四.我們會與誰分享閣下的資料？',
        text1: '我們會使用第三方支援服務，例如使用WeChat公共平台來提供帳戶驗證服務。我們使用這些第三方服務來處理或儲存閣下的資訊時，會以本政策所載的目的為限。我們也會和Globalsim相關集團公司共用閣下的資訊，並根據法律要求來共用。除以上所列之目的外，若無閣下的事前明文同意， Travel Call 不會與第三方共用閣下的資料。任何我們與之分享用戶資訊的第三方服務商（由我們所揀選），都會提供與本政策所述相同，或者同等級的用戶資訊保護標準。'
      },
      five: {
        title: '五.我們保留閣下資料的時間會持續多久？',
        text1: '我們保留閣下資訊的時間會依據資訊類型而定，例如登入資料會保留長達 90 天，自收集資料之日起算。'
      },
      six: {
        title: '六.我要如何行使我對資料的權利？',
        text1: '閣下對閣下的資料及我們使用閣下資料的方式有特殊權利。這些權利包含閣下存取資料的方式、消除資料的方式、限制使用閣下資料的方式、拒絕使用資料，以及取得閣下的資訊副本。'
      },
      seven: {
        title: '七.爭議解決',
        text1: '感謝您選購阿東基的產品。如果您有任何疑問，需要特別技術幫助/產品問題，請直接通過以下方式與我們聯繫。我們希望能收到您的來信，並儘最大努力為您提供所有解決方案。',
        text2: '',
        text3: 'E-mail: globalsimhk@gmail.com'
      },
      eight: {
        title: '八.我們如何向閣下通知變更？',
        text1: ' 若本隱私政策有任何重大變更，在變更生效前，我們會傳送通知給閣下。',
        text2: '我們重視閣下的隱私。本隱私政策旨在告知閣下，對於閣下向我們提供的任何資訊，或閣下因使用 Travel Call 而產生之資訊，閣下可以做出的選擇以及我們的慣例。',
        text3: '使用我們的服務（例如 Travel Call 行動應用程式、阿東基公司網站  adonkilimited.com 或提供 Travel Call 服務之任何第三方平台）（合稱為「 Travel Call 」）包含處理閣下的資訊之行為。閣下有必要瞭解對閣下資訊的收集與使用過程，以及閣下可以如何對其進行管理，這些都是很重要的資訊。請詳閱此隱私政策。'
      },
      nice: {
        title: '九.聯絡我們',
        text1: '感謝您選購阿東基的產品。如果您有任何疑問，需要特別技術幫助/產品問題，請直接通過以下方式與我們聯繫。我們希望能收到您的來信，並儘最大努力為您提供所有解決方案。',
        text2: '',
        text3: 'E-mail: contact@travelcall.net'
      },
      update: {
        text1: '阿東基有限公司-最後修訂'
      }
    },
    regulation: {
      title: ' Travel Call 服務條款',
      clause: {
        clauseTitle1: ' 「 Travel Call 」服務計劃同意書 (香港號碼)',
        clause1: ' 1、以上服務提供於微信「 Travel Call 」公眾號綁定香港號碼查閱及發送短訊服務。阿東基(「ADONKI」)亦可提供實體智能卡予客戶攜號轉台或使用話音﹑數據及手機發送短訊服務，唯客戶需要繳付智能卡費用及／或速遞費用（如適用）。話音﹑數據及手機發送短服務需另行收費。',
        clause2: ' 2、於微信發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽阿東基網頁adonkilimited.com或本公眾號',
        clause3: ' 3、當服務有效期屆滿前，阿東基將發送訊息予客戶登記之香港號碼提示客戶，客戶可於已於綁定香港號碼的微信「 Travel Call 」公眾號查閱，並可於效期屆滿前自行於本公眾號或阿東基網頁adonkilimited.com繳費以延長服務有效期',
        clause4: ' 4、當服務有效期完結時，服務會被暫停。客戶可於微信或阿東基網頁繳費並重啓服務。暫停期間之訊息將不獲補發',
        clause5: ' 5、如服務因任何原故而停用超過7日或終止服務，客戶同意屆時必須放棄該分配的香港號碼並歸還予阿東基',
        clause6: ' 6、服務計劃中的香港號碼不能更改',
        clause7: ' 7、如服務因任何原故而停用，所預繳之費用將不獲退還',
        clause8: ' 8、任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品。',
        clause9: ' 9、此服務受阿東基的《一般條款及條件》約束，詳情請瀏覽阿東基網頁',
        clause10: ' 10、上述資料為閣下自願提供，如有資料錯漏，阿東基可能未能為閣下提供所申請之服務，阿東基有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途',
        clause11: ' 11、阿東基保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以阿東基之決定為最終決定，客戶須受彼等約束',
        clauseTitle2: ' 「 Travel Call 」服務計劃同意書 (香港號碼-攜號轉台服務)',
        clause12: ' 12、以上服務提供於微信「 Travel Call 」公眾號綁定香港號碼查閱及發送短訊服務。阿東基(「阿東基」)亦可提供實體智能卡予客戶攜號轉台或使用話音﹑數據及手機發送短訊服務，唯客戶需要繳付智能卡費用及／或速遞費用（如適用）。話音﹑數據及手機發送短服務需另行收費',
        clause13: ' 13、於微信發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽阿東基網頁adonkilimited.com或本公眾號',
        clause14: ' 14、當服務有效期屆滿前，阿東基將發送訊息予客戶登記之香港號碼提示客戶，客戶可於已於綁定香港號碼的微信 「 Travel Call 」公眾號查閱，並可於效期屆滿前自行於本公眾號或阿東基網頁adonkilimited.com繳費以延長服務有效期',
        clause15: ' 15、當服務有效期完結時，服務會被暫停。客戶可於微信或阿東基網頁繳費並重啓服務。暫停期間之訊息將不獲補發',
        clause16: ' 16、如服務因任何原故而停用超過7日或終止服務，客戶同意屆時必須放棄該分配的香港號碼並歸還予阿東基',
        clause17: ' 17、服務計劃中的香港號碼不能更改',
        clause18: ' 18、如服務因任何原故而停用，所預繳之費用將不獲退還',
        clause19: ' 19、任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品',
        clause20: ' 20、本人明白有關流動號碼的轉攜並不影響有關流動號碼成功轉攜前本人在供號網絡營辦商適用的服務條款與細則下對供號網絡營辦商的責任',
        clause22: ' 21、生效時間受供號網絡營辦商確認上述資料及供號網絡營辦商與阿東基之間按電訊管理局局長所發出的與實施流動電話號碼可攜性有關的實務守則技術安排的限制。阿東基獲明示授權更改阿東基合理地認為合適的生效時間',
        clause23: ' 22、有關流動號碼若由於本人未有提供完整的資料，或提供錯誤或失實的資料或因阿東基未能合理控制的任何理由，而導致流動電話號碼無法攜帶至阿東基的網絡，阿東基有權取消本轉攜申請',
        clause24: ' 23、除任何無法卸除的法律責任外，本人同意因本申請和相關號碼轉攜安排引致或造成本人或其他任何人士蒙受損失或損害，阿東基無需對本人或任何其他人士負上法律責任 (不論是在合約、侵權或其他方面)。 ',
        clause25: ' 24、此服務受阿東基的《一般條款及條件》約束，詳情請瀏覽阿東基網頁',
        clause26: ' 25、上述資料為閣下自願提供，如有資料錯漏，阿東基可能未能為閣下提供所申請之服務，阿東基有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途',
        clause27: ' 26、阿東基保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以阿東基之決定為最終決定，客戶須受彼等約束',
        clauseTitle3: ' 「 Travel Call 」服務計劃同意書 (中國內地號碼)',
        clause28: ' 27、以上服務不提供實體智能卡',
        clause29: ' 28、以上服務只提供於「 Travel Call 」微信公眾號綁定中國內地號碼查閱及發送短訊服務，現階段並不包括話音或數據服務。發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽阿東基網頁adonkilimited.com',
        clause30: ' 29、當服務有效期屆滿前，阿東基(「阿東基」)將發送訊息予客戶登記之中國內地號碼提示客戶，客戶可於已於綁定中國內地號碼的「  Travel Call 」微信公眾號查閱，並可於效期屆滿前自行於微信或阿東基網頁阿東基繳費以延長服務有效期',
        clause31: ' 30、當服務有效期完結時，服務會被暫停。客戶可於微信或阿東基網頁繳費並重啓服務。暫停期間之訊息將不獲補發',
        clause32: ' 31、如服務因任何原故而停用超過30日或終止服務，客戶同意屆時必須放棄該分配的中國內地號碼並歸還予阿東基',
        clause33: ' 32、服務計劃中的中國內地號碼不能更改',
        clause34: ' 33、服務計劃中的中國內地號碼祇適用於「 Travel Call 」服務',
        clause35: ' 34、如服務因任何原故而停用，所預繳之費用將不獲退還',
        clause36: ' 35、任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品',
        clause37: ' 36、中華人民共和國工業和信息部文件《電話用戶真實身份信息登記實施規範》，申請中國內地流動電話號碼必須實名登記，實名登記的年齡範圍必須在16歲以上。阿東基須向閣下蒐集閣下的個人資料，包括姓名、流動電話號碼、聯絡方法﹑港澳身份證﹑台灣居民來往大陸通行證、中國公民身份證、護照或其它身份證明文件﹑免冠像片及自拍影片的資料等(「上述資料」)，以協助閣下向中國內地當局辦理實名登記(「上述登記」)。上述資料會按中國內地政府推行的流動電話號碼實名登記政策有所更改。閣下沒有義務向阿東基提供上述資料，但如閣下不提供個人資料，中國內地當局會按相關政策指令停止閣下的中國內地號碼服務，閣下將無法開通使用或繼續使用涉及中國內地流動電話號碼的電訊通訊服務，詳情請瀏覽阿東基網頁adonkilimited.com',
        clause38: ' 37、用戶如有虛假交易的行為﹑以轉售或詐騙為目的使用本服務，阿東基有權在無任何補償或事先通知情況下，終止閣下的中國內地號碼服務',
        clause39: ' 38、用戶不得將 Travel Call 服務用於電信資訊網路詐騙及其他違法行為，如出現電話詐騙、網路詐騙、垃圾短信投訴情況，阿東基有權在無任何補償或事先通知情況下，永久終止閣下的 Travel Call 號碼。',
        clause40: ' 39、此服務受阿東基的《一般條款及條件》約束，詳情請瀏覽阿東基網頁adonkilimited.com',
        clause41: ' 40、上述資料為閣下自願提供，如有資料錯漏，阿東基可能未能為閣下提供所申請之服務，阿東基有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途',
        clause42: ' 41、阿東基保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以阿東基之決定為最終決定，客戶須受彼等約束',
        clauseEnd: ' 本人/本公司已細閱及明白本附加協議之條款/及條件，並同意受彼等約束。'
      }
    },
    charge: {
      title: ' Travel Call 產品收費表',
      select: {
        option1: '所有套餐',
        option2: '中國香港號碼套餐',
        option3: '中國內地號碼套餐'
      },
      price: '價錢',
      dayNum: '日數',
      receiveMsg: '接收短訊',
      data: '流動數據',
      limitless: '無限',
      service: '服務',
      phoneTime: '通話分鐘',
      phoneTimeAndData: '通話分鐘、流動數據',
      notAvailable: '不適用',
      day: '天',
      minute: '分鐘',
      hk: '(香港)',
      mo: '(澳門)',
      cn_mo: '(中國及澳門)',
      hkTableTitle: '香港號碼套餐',
      package: {
        p1: '微信收短信 （免SIM卡套餐）',
        p2: '實體 SIM 卡',
        p3: 'eSIM 套餐',
        p4: '實體 SIM 卡'
      },
      tips: {
        t1: '(只適用於香港地區)',
        t2: '( 適用於中國香港 )',
        t3: '(只適用於香港及澳門地區)',
        t4: '( 適用於中國香港及澳門 )',
        t5: '( 適用於中國香港及澳門 )',
        t6: '( 適用於中國內地、香港、澳門、台灣 )',
        t7: '( 適用於中國內地、香港、澳門、台灣、美國、加拿大、韓國、日本、新加坡、馬來西亞以及泰國 )',
        t8: '( 適用於中國內地和香港 )',
        t9: '(只適用於香港地區)',
        t10: '(適用於多個地區)'
      }
    },
    question: {
      title: ' Travel Call 常見問題',
      title2: '我要反饋',
      line01: {
        title: '原微信用戶，如何使用新版本APP？',
        content1: '第一步）先在新版本APP上，用電郵註冊一個會員 ； 第二步）新會員登入APP ；第三步） App首頁->兌換香港號碼； 第四步）ICCID綁定成功後，重新登入即可使用已辦理的號碼；',
        content2: ''
      },
      line02: {
        title: ' Travel CallAPP有哪幾種撥號方式【適用：iOS/Andriod】',
        content1: '',
        content2: ''
      },
      line03: {
        title: ' Travel Call 號碼收發短信的規則是怎樣的？【適用：iOS/Andriod】',
        content1: '',
        content2: ''
      },
      line04: {
        title: '如何設置 Travel CallAPP系統權限【適用：Andriod】',
        content1: '以華為品牌手機為例，如下圖：',
        content2: ''
      },
      line05: {
        title: '如何設置 Travel CallAPP後台運行？【適用：Andriod】',
        content1: '',
        content2: ''
      },
      line06: {
        title: '來電的時候，只聽到鈴聲，看不到接聽界面，如何設置？【適用：Andriod】',
        content1: '手機通知權限設置裡面所有能打開的權限全部打開【給予】，具體設置請參考手機說明書。',
        content2: ''
      },
      line07: {
        title: '如何查看已經辦理的號碼信息？【適用：iOS/Andriod】',
        content1: '點擊「個人」->「我的產品」',
        content2: ''
      },
      line08: {
        title: '發送短信時，出現「不正確的目的號碼」，如何處理？【適用：iOS/Andriod】',
        content1: '可能的原因是發送號碼選擇了 Travel Call 大陸號碼，或者接收號碼是大陸移動號碼，具體請參考第3點： Travel Call 號碼收發短信規則。',
        content2: ''
      },
      line09: {
        title: '撥打電話時，出現閃斷或者沒反應，如何解決？【適用：iOS/Andriod】',
        content1: '可能的原因是沒有選擇正確的主叫號碼或者是錯誤的撥號方式，比如：主叫號碼是 Travel Call 香港號碼，但撥號時，沒有輸入正確的區號，具體請參考第2點： Travel Call APP撥號方式',
        content2: ''
      },
      line10: {
        title: '別人撥打我 Travel Call 號碼時，無法撥通，如何解決？【適用：iOS/Andriod】',
        content1: '可能的原因是 Travel CallAPP已經退出，請重新啓動APP即可，如想保持APP一直在線狀態，請在手機系統中設置APP後台運行權限，具體設置請參考第5點：設置 Travel Call APP後台運行；',
        content2: ''
      },
      line11: {
        title: '電話接通時，對方聽不到我說話或者我聽不到對方說話，如何解決？【適用：iOS/Andriod】',
        content1: '1）可能的原因是當前的網絡信號不好，請使用WI-FI或者移動到網絡好的地方再嘗試',
        content2: '2）也有可能是手機的安全軟件禁止  Travel CallAPP聯網，請檢查安全軟件的設置，可以把 Travel Call APP放入到安全軟件的白名單中；'
      },
      line12: {
        title: 'APP升級後，每次打開APP時都需要重新登錄，如何解決？【適用：Andriod】',
        content1: '請關閉  Travel CallAPP進程後，重新登錄APP即可解決；',
        content2: ''
      },
      line13: {
        title: '登錄時，出現登錄異常界面，如何處理？【適用：iOS/Andriod】',
        content1: '方法1: 檢查手機的網絡設置是否正常， 或者手機信號是否正常；',
        content2: '方法2: 如果方法1無法解決，請按照界面提示進行報障；'
      },
      line14: {
        title: '手機通知欄中看到短信通知信息，但進入APP後看不到該條短信？【適用：iOS/Andriod】',
        content1: '估計是版本衝突造成的，請先卸載現有的APP版本，然後重新安裝APP。',
        content2: ''
      }
    },
    feedback: {
      head: '我要反饋',
      title: '在您使用過程中，如有出現使用不順暢的地方，請向我們反饋意見，幫助Travel Call產品不斷改進。',
      time: '發生時間',
      year: '年',
      month: '月',
      day: '日',
      type: '問題類型',
      selectType: '請選擇問題類型',
      cancle: '取消',
      sure: '確定',
      view: '問題表現',
      selectView: '請選擇問題表現',
      net: '網絡方式',
      selectNet: '請選擇網絡方式',
      region: '所在地區',
      inputRegion: '請輸入所在地區',
      desc: '補充說明',
      descTip: '最多200字',
      contactInfo: '聯絡電郵',
      inputContactInfo: '請輸入聯絡電郵',
      inputFailContactInfo: '電郵地址格式不正確',
      submit: '提交反饋',
      success: '提交成功！',
      successTips1: '如需更快捷的服務，請透過WhatsApp同我們聯絡：+852 6398 7656',
      successTips2: '周一至周日 12:00-21:00',
      successBtn: '我知道了',
      fail: '提交失敗',
      feedbackType: [{
        TYPE_ID: '1',
        TYPE_SORT: '1',
        TYPE_NAME: '網絡問題'
      },
      {
        TYPE_ID: '2',
        TYPE_SORT: '2',
        TYPE_NAME: '權限問題'
      }
      ],
      networkInfo: [{
        NETWORK_ID: '1',
        TYPE_SORT: '1',
        NETWORK_NAME: 'WIFI'
      },
      {
        NETWORK_ID: '2',
        TYPE_SORT: '2',
        NETWORK_NAME: '3G'
      },
      {
        NETWORK_ID: '3',
        TYPE_SORT: '3',
        NETWORK_NAME: '4G'
      }
      ],
      feedbackDetail: [{
        TYPE_ID: '1',
        DETAIL_ID: '1',
        TYPE_SORT: '1',
        DETAIL_NAME: '斷斷續續'
      },
      {
        TYPE_ID: '1',
        DETAIL_ID: '2',
        TYPE_SORT: '2',
        DETAIL_NAME: '聲音模糊'
      },
      {
        TYPE_ID: '2',
        DETAIL_ID: '3',
        TYPE_SORT: '3',
        DETAIL_NAME: '出錯'
      },
      {
        TYPE_ID: '2',
        DETAIL_ID: '4',
        TYPE_SORT: '4',
        DETAIL_NAME: '體驗差'
      }
      ]
    },
    contactUs: {
      t1: '阿東基 微信公眾號',
      tips1: '1. 儲存二維碼到手機，啓動微信應用程式',
      tips2: '2. 按畫面按右上方的「+」，再按「掃描」並打開相簿點選已儲存的QR Code',
      tips3: '3. 掃描後進入「博元訊息」官方帳戶，按「關注」即可瀏覽',
      btn: '儲存二維碼'
    },
    bindICCID: {
      head: '兌換香港號碼',
      label: {
        iccid: 'ICCID ',
        iccidWhere: '（儲值卡上 20 位數） ',
        pin: 'PIN碼 ',
        verifyPin: 'PIN碼（儲值卡上 6 位數） ',
        pinWhere: '請在儲值卡上找到 6 位PIN碼數字',
        canNotFindPin: '無法使用PIN碼？',
        canNotUsePinTips1: '如閣下失去了PIN碼，請透過電話聯絡我們客戶服務專員：(852) 6469 6649 。',
        canNotUsePinTips2: '（ 星期一至五 早上 9:00 - 下午 6:00 ）',
        sysErrorTips: '系統繁忙，請稍後再試或者聯繫客服人員! ',
        exchangeSuccess: '兌換成功! '
      },
      btn: {
        confirm: '確認',
        exchange: '兌換'
      },
      inputTips: {
        iccid: '輸入 20 位 ICCID ',
        pin: '輸入 6 位 PIN碼 '
      },
      whatIccidTips: {
        title: '什麼是 ICCID？',
        tips: '如上圖紅框所示，於閣下已購買的儲值卡上印有 20 位 ICCID 識別碼，請輸入該 ICCID 別碼進行驗證。'
      },
      whatPinTips: {
        title: 'PIN碼位置',
        tips: '如上圖紅框所示，於閣下已購買的儲值卡上印有 6 位儲值卡密碼（SIM PIN）請輸入該 PIN 碼進行驗證。'
      }
    }
  },
  delUserData: {
    head: '清除用戶數據',
    stepList: ['輸入Email', '->驗證Email', '->確認刪除', '->數據清理'],
    esT1: '應用名稱(App Name): eSender',
    esT2: '開發商(Developer): Multibyte Info Technology Ltd.',
    gsT1: '應用名稱(App Name): Travel Call',
    gsT2: '開發商(Developer): ADONKI LIMITED',
    label1: '請輸入妳的賬號郵箱:',
    label2: '說明: 該郵箱為妳註冊賬號時的有效郵箱地址',
    label3: '請輸入驗證碼:',
    label4: '我們需要驗證您的身份，已將驗證信息傳送到:',
    label5: '請在10分鐘內內輸入驗證碼',
    label6: '校驗通過，您是否確認刪除賬號',
    label7: '及相關數據?',
    label8: '一旦確認，您的賬號及數據將永久刪除。',
    label9: '您的賬號及數據已被清除,再次感謝使用我們的產品,如需重新使用我們的產品，請再次註冊即可:',
    inputTip1: '請輸入正確的電郵',
    inputTip2: '請輸入正確的驗證碼',
    fail1: '驗證信息傳送失敗，請聯系管理員',
    fail2: '驗證碼驗證失敗，請聯系管理員',
    fail3: '清除用戶數據失敗，請聯系管理員',
    btn: {
      back: '返回',
      next: '下一步',
      prev: '上一步',
      confirm: '確認',
      cancel: '取消',
      complete: '完成'
    }
  },
  notice: {
    head: '通知中心',
    unRead: '未讀',
    read: '已讀通知',
    readALL: '全部設為已讀',
    empty: '暫無通知',
    latestNews: '最新通知',
    noMore: '沒有更多的通知',
    warn: '獲取消息列表失敗',
    more: '了解更多',
    del: '刪除',
    menu: {
      all: '所有通知'
    }
  },
  brandHKNew: {
    title: '全新香港號碼',
    tips1: '新號首發，限量供應，沒有使用記錄。',
    tips2: '無SIM卡服務，App和微信收取短訊，App接聽撥打電話。',
    tips3: 'App端單獨購買的號碼，不能在微信收取短信。',
    attention: '請註意',
    attentionTips1: '中國香港手機號需【實名認證】方可提供 服務，根據當地法規需提供仍虛於有效期 內的 中國香港身份證/中國澳門身份證/ 港澳通行證/臺胞證/護照等證件，中國內 地居民身份證無法進行實名認證。請確認 是否有以上證件.',
    attentionTips2: '本套餐香港號碼，僅確保非循環使用的號 碼以及只提供通信服務，不保證任何平臺 或App 的註冊是否成功.',
    attentionTips3: '如果因為個人問題無法完成實名，辦理退款時將扣除HK$20元號碼占用費用.',
    btn1: '沒有',
    btn2: '有',
    btn3: '不清楚',
    btn4: '清楚',
    number: {
      title: '選擇心儀號碼.....',
      content: '換一批號碼',
      selectTip: '(只能換一次)',
      tip: '請先選擇號碼',
      warn: '獲取可登記香港號碼列表失敗',
      tipTitle: '無法開通手機號',
      tipContent: '你的申請已達到上限，每個帳戶最多可以申請 2 個中國香港手機號及 1 個中國内地手機號。',
      noNumberTips1: '全新香港手機號被搶光了!',
      noNumberTips2: '請聯絡我們的客服。'
    },
    member: {
      title: '香港免 SIM 卡服務',
      content: '香港特區政府於2021年6月1日公佈訂立《電訊（登記用戶識別卡）規例》，並於同年9月1日實施，以落實電話智能卡實名登記制度，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。',
      userlabel: '客戶資料',
      userTip: '輸入姓名',
      userWarn: '請輸入姓名',
      mobileTip: '輸入聯絡電話',
      mobileWarn: '請輸入正確的手機號碼',
      codeLabel: '優惠碼',
      codeTip: '優惠碼（如有）',
      codeWarn: '請輸入正確的優惠碼',
      codeOk1: '成功使用，已額外獲取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '優惠碼無效，是否繼續購買?',
      useBut: '繼續',
      cancleUseBut: '取消',
      mobilePrefixTitle: '選擇電話區號',
      mobilePrefixList: [
        {name: '中國香港（+852）', value: '852'},
        {name: '中國内地（+86）', value: '86'},
        {name: '中國澳門（+853）', value: '853'},
        {name: '中國台灣（+886）', value: '886'},
        {name: '美國 / 加拿大（+1）', value: '1'},
        {name: '英國（+44）', value: '44'},
        {name: '馬來西亞（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律賓（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰國（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韓國（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法國（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德國（+49）', value: '49'},
        {name: '其他', value: ''}
      ]
    },
    confirm: {
      title: '確認訂單',
      tetle2: '香港免 SIM 卡服務',
      code: '優惠碼',
      price: '總額',
      plan: '計劃號碼',
      username: '輸入姓名',
      mobile: '聯絡電話',
      add: '加',
      day: '天有效期',
      update: '修改'
    },
    letter: {
      title: '「易博通」服務計劃同意書（香港號碼）',
      statement: '個人聲明',
      statementInfo: '我已經閱讀和了解廣州博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條「收集個人資料」的規定，請在以下適當空格加上「√」號：',
      statementDetail1: '本人同意以上條款及細則。',
      statementDetail4: '本人同意博元使用本人的個人資料直接促銷任何服務產品。',
      statementDetail2: '本人同意博元使用本人的個人資料，但僅限於延續服務安排及由博元直接提供的電訊服務 (包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
      statementDetail3: '本人不同意博元使用任何本人的個人資料促銷用途。',
      content: [
        '以上服務提供於「易博通eSender」微信公眾號及/或易博通APP綁定香港號碼查閱及發送短訊服務。廣州博元訊息科技有限公司 (「博元」) 亦可提供實體智能卡予客戶攜號轉台或使用話音﹑數據及手機發送短訊服務，唯客戶需要繳付智能卡費用及／或速遞費用 (如適用)。話音﹑數據及手機發送短服務需另行收費。',
        '於易博通微信公眾號及/或易博通APP發送短訊只提供予已選用套餐的戶口，並需另行收費，費用會於戶口內餘額扣除，有關收費詳情請瀏覽博元網頁 www.multi-byte.com 或本公眾號。',
        '當服務有效期屆滿前，博元將發送訊息予客戶登記之香港號碼提示客戶，客戶可於已於綁定香港號碼的易博通微信公眾號及/或易博通APP查閱，並可於效期屆滿前自行於易博通微信公眾號﹑易博通APP或博元網頁www.multi-byte.com 繳費以延長服務有效期。',
        '當服務有效期完結時，服務會被暫停。客戶可於易博通微信公眾號﹑易博通APP或博元網繳費並重啟服務。暫停期間之訊息將不獲補發。',
        '如服務因任何原故而停用超過 3 日或終止服務，客戶同意屆時必須放棄該分配的香港號碼並歸還予博元。',
        '服務計劃中的香港號碼不能更改。',
        '如服務因任何原故而停用，所預繳之費用將不獲退還。',
        '任何優惠不得自由轉讓、退回現金及/ 或不可兌換其他服務及/ 或產品。',
        '根據香港《電訊 (登記用戶識別卡) 規例》落實電話智能卡實名登記制度的實施安排，保障健全的電訊服務及通訊網絡的安全，防止和協助偵查涉及使用電話儲值卡的罪案。申請香港流動電話號碼必須實名登記，個人用戶須提供身分證明文件 (香港身份證或其他可接受的身分證明文件如旅客的"旅遊證件") 內的資料，包括姓名、出生日期和身分證明文件號碼及其照片，以作登記。若公司或企業要登記成為電話智能卡用戶，則須提供其商業登記資料及指定某人士作為代表或負責人，並提供該名人士的個人資料。16歲以下人士如需登記電話智能卡服務，相關登記必須得到一位成人的確認，電訊商亦會登記該名成人的資料。如閣下不提供個人資料，閣下將無法開通使用或繼續使用涉及香港流動電話號碼的電訊通訊服務，詳情請瀏覽博元網頁www.multi-byte.com。',
        '此服務受廣州博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁。',
        '上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申請之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核﹑追討債務﹑市場研究﹑及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途。',
        '廣州博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束。'
      ],
      warn: '請同意有關條款'
    }
  },
  polPlan: {
    title: '波蘭手機號登記',
    registerErr: '預註冊波蘭號碼失敗',
    registerOk: '預註冊波蘭號碼成功',
    plan: {
      title: '波蘭手機號',
      content: '無 SIM 卡，微信和 App 收取短訊。',
      content2: 'App端單獨購買的號碼，不能在微信收取短信。',
      selectTip: '請選擇你的計劃.....',
      tip: '請先選擇套餐',
      warn: '暫無套餐可供銷售'
    },
    number: {
      title: '選擇心儀號碼.....',
      content: '換一批號碼',
      selectTip: '(只能換一次)',
      tip: '請先選擇號碼',
      warn: '獲取可登記波蘭號碼列表失敗',
      tipTitle: '無法開通手機號',
      tipContent: '你的申請已達到上限，每個帳戶最多可以申請 1 個波蘭手機號。'
    },
    member: {
      title: '波蘭手機號',
      content: '此波蘭手機號套餐計劃為無 SIM卡計劃，計劃只限於 APP或微信內收短訊使用。（計劃並不包括通話、 發短訊和數據功能）',
      userlabel: '客戶資料',
      userTip: '輸入姓名',
      userWarn: '請輸入姓名',
      mobileTip: '輸入聯絡電話',
      mobileWarn: '請輸入正確的手機號碼',
      codeLabel: '優惠碼',
      codeTip: '優惠碼（如有）',
      codeTip2: '輸入優惠碼後， 在成功開通後可額外增加15日。',
      codeWarn: '請輸入正確的優惠碼',
      codeOk1: '成功使用，已額外獲取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '優惠碼無效，是否繼續購買?',
      useBut: '繼續',
      cancleUseBut: '取消',
      mobilePrefixTitle: '選擇電話區號',
      mobilePrefixList: [
        {name: '中國香港（+852）', value: '852'},
        {name: '中國内地（+86）', value: '86'},
        {name: '中國澳門（+853）', value: '853'},
        {name: '中國台灣（+886）', value: '886'},
        {name: '美國 / 加拿大（+1）', value: '1'},
        {name: '英國（+44）', value: '44'},
        {name: '馬來西亞（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律賓（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰國（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韓國（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法國（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德國（+49）', value: '49'},
        {name: '其他', value: ''}
      ]
    },
    confirm: {
      title: '確認訂單',
      tetle2: '波蘭手機號',
      code: '優惠碼',
      price: '總額',
      plan: '計劃號碼',
      username: '輸入姓名',
      mobile: '聯絡電話',
      add: '加',
      day: '天有效期',
      update: '修改'
    },
    letter: {
      title: '「易博通香港eSender HK」服務計劃同意書（波蘭號碼）',
      statement: '個人聲明',
      statementInfo: '我已經閱讀和了解廣州博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條「收集個人資料」的規定，請在以下適當空格加上「√」號：',
      statementDetail1: '本人同意以上條款及細則。',
      statementDetail4: '本人同意博元使用本人的個人資料直接促銷任何服務產品。',
      statementDetail2: '本人同意博元使用本人的個人資料，但僅限於延續服務安排及由博元直接提供的電訊服務 (包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
      statementDetail3: '本人不同意博元使用任何本人的個人資料促銷用途。',
      content: [
        '以上服務提供於微信「易博通香港 eSender HK」公眾號綁定波蘭號碼查閱短訊服務。',
        '當服務有效期屆滿前，博元將發送訊息提示給予已登記波蘭號碼的客戶，客戶可於已於綁定波蘭號碼的微信「易博通香港eSenderHK」之公眾號查閱，並可於有效期屆滿前自行在本公眾號繳費以延長服務有效期。',
        '當服務有效期完結時，服務會被暫停。客戶可於微信「易博通香港 eSender HK」公眾號繳費並重啟服務。暫停期間之訊息將不會補發。',
        '如服務因任何原故而停用超過3日或終止服務，客戶必須同意放棄該分配的波蘭號碼，並歸還予博元。',
        '服務計劃中嘅波蘭號碼將不能更改。',
        '如服務因任何原故而停用，所預繳之費用將不獲退還。',
        '任何優惠不得自由轉讓、退回現金及/或不可兌換其他服務及/或產品。',
        '此服務受博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁。 ',
        '上述資料為閣下自願提供，如資料有錯漏，博元訊息可能未能為閣下提供所申請之服務。博元訊息有權使用上述資料為閣下提供服務或通知閣下優惠推廣活動。如有需要，將披露予第三方作信用覆核、追討債務、市場研究、及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途。',
        '博元訊息科技有限公司保留更改本服務計劃同意書之條款及條件與優惠之權利，恕不另行通知，如有任何爭議，概以博元之決定為最終決定，客戶須受彼等約束。'
      ],
      warn: '請同意有關條款'
    }
  },
  usPlan: {
    title: '美國手機號登記',
    registerErr: '預註冊美國號碼失敗! 若您已申請但未支付，需等1小時後再試；若您無申請過，就需聯絡我們的客服。',
    registerOk: '預註冊美國號碼成功',
    plan: {
      title: '美國手機號',
      content: '無 SIM 卡，App 收取短訊。',
      content2: 'App端單獨購買的號碼，不能在微信收取短信。',
      selectTip: '請選擇你的計劃.....',
      tip: '請先選擇套餐',
      warn: '暫無套餐可供銷售'
    },
    member: {
      title: '美國手機號',
      content: '此美國手機號套餐計劃為無 SIM卡計劃，計劃只限於 APP或微信內收短訊使用。（計劃並不包括通話、 發短訊和數據功能）',
      userlabel: '客戶資料',
      userTip: '輸入姓名',
      userWarn: '請輸入姓名',
      mobileTip: '輸入聯絡電話',
      mobileWarn: '請輸入正確的手機號碼',
      codeLabel: '優惠碼',
      codeTip: '優惠碼（如有）',
      codeTip2: '輸入優惠碼後， 在成功開通後可額外增加15日。',
      codeWarn: '請輸入正確的優惠碼',
      codeOk1: '成功使用，已額外獲取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '優惠碼無效，是否繼續購買?',
      useBut: '繼續',
      cancleUseBut: '取消',
      mobilePrefixTitle: '選擇電話區號',
      mobilePrefixList: [
        {name: '中國香港（+852）', value: '852'},
        {name: '中國內地（+86）', value: '86'},
        {name: '中國澳門（+853）', value: '853'},
        {name: '中國臺灣（+886）', value: '886'},
        {name: '美國 / 加拿大（+1）', value: '1'},
        {name: '英國（+44）', value: '44'},
        {name: '馬來西亞（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律賓（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰國（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韓國（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法國（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德國（+49）', value: '49'},
        {name: '其他', value: ''}
      ],
      contactInfo: '聯絡信息',
      firstNameTip: 'First Name',
      firstNameWarn: '請輸入First Name',
      lastNameTip: 'Last Name',
      lastNameWarn: '請輸入Last Name',
      emailTip: '輸入有效電郵地址',
      emailWarn: '輸入有效電郵地址'
    },
    confirm: {
      title: '確認訂單',
      title2: '美國手機號',
      code: '優惠碼',
      price: '總額',
      plan: '計劃號碼',
      username: '輸入姓名',
      mobile: '聯絡電話',
      add: '加',
      day: '天有效期',
      update: '修改',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email'
    },
    letter: {
      title: '「易博通eSender」服務計劃同意書(美國號碼）',
      statement: '個人聲明',
      statementInfo: '我已經閱讀及瞭解博元訊息科技有限公司私隱政策及個人資料收集聲明，第2條“收集個人資料”的規定，請在以下適當空格加上【√】號：',
      statementDetail1: '本人同意以上條款及細則。',
      statementDetail4: '本人同意博元使用本人的個人资料直接促銷任何服務產品。',
      statementDetail2: '本人同意博元使用本人的個人资料，但僅限於延續服務安排及由博元直接提供的电訊服务(包括但不限於流動語音，數據服務，國際漫遊服務/長途電話服務產品促銷資訊)。',
      statementDetail3: '本人不同意博元使用任何本人的個人资料促銷用途。',
      content: [
        '以上服務提供於微信"易博通 eSender"公眾號綁定美國號碼查閱短訊服务。',
        '當服務有效期屆滿前，博元將發送訊息予客戶登記之美國號碼提示客戶，客戶可於已於綁定美國號碼的微信"易博通香港eSenderHK"公眾號查閱，並可於有效期屆滿前自行於本公眾號繳費以延長服務有效期。',
        '當服務有效期完結時，服務會被暂停。客戶可於微信"易博通 eSender "App繳費並重啟服務。暫停期間之訊息將不獲補發。',
        '如服务因任何原故而停用超过3日或终止服务，客戶同意屆時必須放棄該分配的英國號碼並 歸還予博元。',
        '服務計劃中的美國號碼不能更改。',
        '如服務因任何原故而停用，所预繳之费用將不獲退還。',
        '任何優惠不得自由轉讓、退回現金及/或不可兌换其他服务及/或產品。',
        '此服務受博元訊息科技有限公司的《一般條款及條件》約束，詳情請瀏覽博元網頁。 ',
        '上述資料為閣下自願提供，如有資料錯漏，博元訊息可能未能為閣下提供所申请之服務，博元訊息有權使用上述資料為閣下提供服務，通知閣下優惠推廣活動，如有需要，披露予第三方作信用覆核、追討债務、市場研究、及在法律規定下或遵從被認可之政府機關要求下披露及經閣下同意使用之其他用途。',
        '博元訊息科技有限公司保留更改本服务計劃同意書之條款及條件與優惠之權利，恕不另行通知，遇有任何爭議，概以博元之決定為最終決定，客户須受彼等約束。'
      ],
      warn: '請同意有關條款'
    }
  },
  esContactUs: {
    head: '聯絡我們',
    onlineTitle: '在線客服',
    online1: '微信客服 eSender',
    online2: 'Facebook eSender',
    online3: 'WhtatsApp',
    telTitle: '客戶服務熱線',
    tel1: '中國內地 (86) 400-888-4333',
    tel2: '中國香港 (852) 21568888',
    tel3: '俄羅斯 eSender.org',
    quesTitle: '常見問題',
    ques1: '有查詢常見問題嗎？你可能會從中得到答案。',
    quesBtn: '前往常見問題',
    sendTitle: '透過微信發送信息',
    send1: '如有任何疑問，可前往微信公眾號與我們聯絡。',
    sendBtn: '前往微信公眾號'
  },
  realNameInfo: {
    head: '實名資料查詢',
    choosePhone: '選擇號碼',
    balance: '余額',
    authPass: '已實名認證',
    authFail: '未實名認證',
    auditing: '實名認證審核中',
    auditing2: '正在審核中',
    unAuth: '沒有實名認證',
    unAuthStatus: '未實名認證，無法使用',
    numberInfo: '號碼資料',
    noPhoneTips: '您當前沒有號碼，請先購買號碼',
    status: '狀態',
    normal: '正常',
    expired: '失效',
    active: '生效',
    numExpired: '過期',
    notRealName: '未實名',
    noNumber: '無號碼',
    endDate: '到期日',
    notApplicable: '不適用',
    certNo: '證件號碼',
    product: '產品屬性',
    licenseNo: '許可編號',
    idType: '身份類型',
    realNameFlag: '實名製信息',
    customerLine: '客服電話',
    registerTime: '入網時間',
    mobile: '手機號碼',
    operation: '運營商',
    customerName: '姓名',
    expiredTime: '到期時間',
    customerStatus: '用戶狀態',
    nodata: '未查詢到資料',
    tips: '*僅限中國大陸號碼資料查詢'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/hk.js